import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import {
  APIConstants,
  ClaimStatusConstants,
  CommonAPIConstants,
  convertDateFormat,
  FilesAPIConstants,
  formatAppointMentDate,
  formatDOSDate,
  IntelliBillConstants,
  NewEncounterConstants,
} from "../utilities/Constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from '@fortawesome/free-regular-svg-icons'
import {
  faCircleCheck,
  faShieldHalved,
  faMinus,
  faPlus,
  faXmark,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import CustomDatePicker from "../components/DatePicker";
import ProviderDropdown from "../components/CascadingDropdown";
import Draggable from "react-draggable";

const NewEncounterPage = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.user.user);

  const { id } = useParams();
  const userPracticeID = userData ? userData.practiceID : null;
  var userId = userData ? userData.userID : null;

  const sAuthToken = useSelector((state) => state.user.token);
  // const NewAuthToken = useSelector((state) => {
  //   const token = state.user.token;
  //   return token ?? state.user.user?.sAuthToken ?? '';
  // });

  // console.log("AuthTOKEN:", sAuthToken);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchPatientText, setSearchPatientText] = useState("");
  const [searchPatientData, setSearchPatientData] = useState([]);
  const [selectedDOB, setSelectedDOB] = useState("");
  const [selectedPatientId, setSelectedPatientID] = useState("");
  const [patientInsData, setPatientInsData] = useState([]);
  const [selectedInsurance, setSelectedInsurance] = useState("");
  const [selectedPatientInsurance, setSelectedPatientInsurance] = useState("");
  const [selectedSecInsurance, setselectedSecInsurance] = useState("-1");
  const [appointmentDate, setAppointmentDate] = useState("");
  const [claimDetails, setClaimDetails] = useState([]);
  const [approveDate, setApproveDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [fromDates, setFromDates] = useState([]);
  const [toDates, setToDates] = useState([]);
  const [selectedPracticeProvider, setSelectedPracticeProvider] = useState("");
  const [practiceProvider, setPracticeProvider] = useState([]);
  const [selectedRenderingProvider, setSelectedRenderingProvider] =
    useState("");
  const [selectedProvidersCategory, setSelectedProvidersCategory] =
    useState(0);
  const [selectAllDropDown, setSelectAllDropDown] = useState([]);
  const [locations, setLocations] = useState([]);
  const [cms33aData, setCMS33aData] = useState([]);
  const [cms33bData, setCMS33bData] = useState([]);
  const [BillingNPIs, setBillingNPIs] = useState([]);
  const [ServiceLocations, setServiceLocations] = useState([]);
  const [selectedCMS33a, setSelectedCMS33a] = useState("0 ");
  const [selectedCMS33b, setSelectedCMS33b] = useState("0");
  const [selectedBillingNPI, setSelectedBillingNPI] = useState("0");
  const [providerCategory, setProviderCategory] = useState([]);
  const [searchFilterData, setSearchFilterData] = useState([]);
  const [statusRadioButton, setStatusRadioButton] = useState([]);
  const [checkedRadioButton, setCheckedRadioButton] = useState([]);
  const [practiceTaxonomycodes, setPracticeTaxonomycodes] = useState([]);
  const [selectedFilterProvider, setSelectedFilterProvider] = useState("-1");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [showButtons, setShowButtons] = useState(false);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState("");
  const [selectedServiceLocation, setSelectedServicelocation] = useState("");
  const [isBOX32checked, setIsBox32Checked] = useState(0);
  const [selectedResubmitCode, setSelectedResubmitCode] = useState("0");
  const [selectedOriginalClaim, setSelectedOriginalClaim] = useState("");
  const [tableDetails, setTableDetails] = useState([]);
  const [selectedLocationRows, setSelectedLocationRows] = useState([]);
  const [isPatientSelected, setIsPatientSelected] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [claimRowsData, setClaimRowsData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedSearchFilter, setSelectedSearchFilter] = useState("");
  const [isInsdata, setisInsdata] = useState(true);
  const [selectedInsData, setSelectedInsData] = useState([]);
  const [btnStatus, setBtnStatus] = useState(null);
  const [denied, setDenied] = useState(false);
  const [showPaidErrorModal, setShowPaidErrorModal] = useState(false);
  // const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
  const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
  const [showEligible, setShowEligible] = useState(false);
  const [showSecondaryEligible, setShowSecondaryEligible] = useState(false);
  const [patientSecInsData, setPatientSecInsData] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedCertification, setSelectedCertification] = useState("");
  const [providers, setProviders] = useState([]);
  const [practiceProvider1, setPracticeProvider1] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [selectedCPTServiceID, setSelectedCPTServiceID] = useState("");
  const [claimIdSearch, setClaimIdSearch] = useState('');
  const [newClaimIdSearch, setNewClaimIdSearch] = useState('');
  const [providerNameSearch, setProviderNameSearch] = useState('');
  const [procedureSearch, setProcedureSearch] = useState('');
  const [grandTotal, setGrandTotal] = useState(0);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [physicianDropdownData, setPhysicianDropdownData] = useState([]);
  const [isPrimarySkipped, setIsPrimarySkipped] = useState(false);
  const [insuranceData, setInsuranceData] = useState([]);
  const [claimNotes, setclaimNotes] = useState("");
  const [priorAuthority, setPriorAuthority] = useState("");
  const [allFilesData, setallFilesData] = useState([]);
  const [attachmentsData, setattachmentsData] = useState([]);
  const [allDocumentData, setallDocumentData] = useState([]);
  const [showEncModal, setShowEncModal] = useState(false);
  const [docRowCheckbox, setdocRowCheckbox] = useState([]);
  const [docAllCheckbox, setdocAllCheckbox] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [selectMethod, setSelectMethod] = useState('');
  const [selectType, setSelectType] = useState('');
  const [searchDocDate, setSearchDocDate] = useState("");
  const [searchDocName, setSearchDocName] = useState("");
  const [searchDocType, setSearchDocType] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [successDeleteModal, setSuccessDeleteModal] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [selectedDocName, setSelectedDocName] = useState('');
  const [selectedDocForDelete, setSelectedDocForDelete] = useState("");
  const [successTimer, setSuccessTimer] = useState(8000);
  const [attachmentTypeData, setattachmentTypeData] = useState([]);
  const [selectedClaimID, setSelectedClaimID] = useState('');


  useEffect(() => {
    let timerId;


    if (showErrorModal || showUploadModal || successDeleteModal) {

      timerId = setTimeout(() => {
        setShowErrorModal(false);
        setShowUploadModal(false);
        setShowDeleteModal(false);
        setSuccessDeleteModal(false)


      }, successTimer);
    }


    return () => {
      clearTimeout(timerId);
    };
  }, [successTimer, showErrorModal, showUploadModal, successDeleteModal]);



  useEffect(() => {
    if (claimDetails) {
      setclaimNotes(claimDetails.EClaimNote);
      setPriorAuthority(claimDetails.PriorAuthority)
    }
  }, [claimDetails]);


  const [rows, setRows] = useState([
    {
      fromDate: "",
      toDate: "",
      procedure: "",
      selectedCPTs: [],
      modDataList: [],
      diagDataList: [],
      mod1: "",
      mod2: "",
      mod3: "",
      diag1: "",
      diag2: "",
      diag3: "",
      diag4: "",
      hideList: false,
      hideMod: false,
      hideMod1: false,
      hideMod2: false,
      hideDiag: false,
      hideDiag1: false,
      hideDiag2: false,
      hideDiag3: false,
      totalCharge: "",
      Adjustment: "",
      SecPendingAmt: "",
      Deductible: "",
      PatientAmount: "",
      AdminWriteOff: "",
      ClaimCPTLineNumber: "",
      unit: "",
      unitCharge: "",
      ID: ""
    },
  ]);

  useEffect(() => {
    document.title = "New Encounter";
    setSearchText("");
  }, [selectedSearchFilter]);
  const FullName = [claimDetails?.LastName, claimDetails?.FirstName]
    .filter(Boolean)
    .join(", ");
  useEffect(() => {
    setSearchPatientText(FullName);
    if (FullName.trim() !== "") {
      setIsPatientSelected(true);
    } else {
      setIsPatientSelected(false);
    }
    setSearchPatientData([]);
  }, [FullName]);




  const validateDocuments = () => {
    for (let i = 0; i < selectedDocs.length; i++) {
      if (!selectedDocs[i].selectType || !selectedDocs[i].selectMethod) {
        setShowValidationModal(true)

        return false;
      }
    }


    return true;
  };

  // Handle Add New Row
  const checkThenAddRow = () => {
    setShowPaidErrorModal(true);
  }
  const handleAddRow = () => {
    setShowPaidErrorModal(false);
    setRows([
      ...rows,
      {
        fromDate: appointmentDate ? appointmentDate : "",
        toDate: appointmentDate ? appointmentDate : "",
        procedure: "",
        selectedCPTs: [],
        modDataList: [],
        diagDataList: [],
        mod1: "",
        mod2: "",
        mod3: "",
        diag1: "",
        diag2: "",
        diag3: "",
        diag4: "",
        hideList: false,
        hideMod: false,
        hideMod1: false,
        hideMod2: false,
        hideDiag: false,
        hideDiag1: false,
        hideDiag2: false,
        hideDiag3: false,
        totalCharge: "",
        Adjustment: "",
        SecPendingAmt: "",
        Deductible: "",
        PatientAmount: "",
        AdminWriteOff: "",
        ClaimCPTLineNumber: "",
        unit: "",
        unitCharge: "",


      },
    ]);
  };

  const handleClaimIdSearchChange = (e) => {
    setClaimIdSearch(e.target.value);
  };

  const handleNewClaimIdSearchChange = (e) => {
    setNewClaimIdSearch(e.target.value);
  };

  const handleProviderNameSearchChange = (e) => {
    setProviderNameSearch(e.target.value);
  };

  const handleProcedureSearchChange = (e) => {
    setProcedureSearch(e.target.value);
  };

  const filteredRows = rows?.filter(row => {
    return (
      (claimIdSearch === '' || row?.ClaimId?.toString().includes(claimIdSearch)) &&
      (newClaimIdSearch === '' || row?.NewClaimId?.toString().includes(newClaimIdSearch)) &&
      (providerNameSearch === '' || row?.providername?.toLowerCase().includes(providerNameSearch?.toLowerCase())) &&
      (procedureSearch === '' || row?.procedure?.toLowerCase().includes(procedureSearch?.toLowerCase()))
    );
  });



  const formatStartDates = fromDates
    ? fromDates.map(convertDateFormat)
    : [new Date().toLocaleDateString("en-US")];
  const formatToDates = toDates
    ? toDates.map(convertDateFormat)
    : [new Date().toLocaleDateString("en-US")];

  const handleRemoveRow = (indexToRemove) => {
    setRows((prevRows) =>
      prevRows?.filter((_, index) => index !== indexToRemove)
    );
  };



  useEffect(() => {
    if (id && !hasLoaded) {
      getClaimStatusData();
      setHasLoaded(true);
    }
  }, [id, claimDetails]);


  useEffect(() => {
    getDropdown();
    getProvider();
    getPhysicianDropdown()
  }, [userData, selectedPatientId]);

  const getProvider = () => {
    const url =
      APIConstants.COMMON_BASE_URL +
      `CommonData/BillingProviders?sInputJSON={"PracticeID":"${userPracticeID}"}`;
    const response = fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${sAuthToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {

        setPracticeProvider1(data);
      })

      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  const getDropdown = () => {
    const url = `${APIConstants.COMMON_BASE_URL}${IntelliBillConstants.GetIntelliDropDowns}?sInputJSON={PracticeID:${userPracticeID},UserId:${userId} }`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',

      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })



      .then((data) => {
        // Extract the relevant data from the response
        const parsedData = JSON.parse(data);

        setSelectAllDropDown(parsedData);

        // Populate the dropdowns with the received data
        setLocations(JSON.parse(parsedData.LocationDetails))

        setCMS33aData(JSON.parse(parsedData.CMSbox33aData));
        setCMS33bData(JSON.parse(parsedData.CMSbox33bData));
        setBillingNPIs(JSON.parse(parsedData.PracticeBillingNPIs));
        setServiceLocations(JSON.parse(parsedData.ServiceLocation));

        setProviderCategory(JSON.parse(parsedData.ProvidersCategories));
        setSearchFilterData(JSON.parse(parsedData.SearchByFilters));
        setStatusRadioButton(JSON.parse(parsedData.StatusRadioButtons));
        setCheckedRadioButton(JSON.parse(parsedData.CheckedInRadioButtons));
        setPracticeTaxonomycodes(JSON.parse(parsedData.PracticeTaxonomycodes));
        setLoading(false);
      })


      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };


  const getPracticeProvidersOnly = () => {
    const url = `${APIConstants.COMMON_BASE_URL}${IntelliBillConstants.GetIntelliDropDowns}?sInputJSON={PracticeID:${userPracticeID},UserId:${userId} }`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',

      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })

      .then((data) => {
        // Extract the relevant data from the response
        const parsedData = JSON.parse(data);
        setPracticeProvider(JSON.parse(parsedData.PracticeProviders));

      })

      .catch((error) => {
        console.error("Error fetching PracticeProviders: ", error);
      });
  };


  const getPhysicianDropdown = () => {


    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientRefPhysician}?PatientID=${selectedPatientId}`;

    // console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`

      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {


        const parsedData = JSON.parse(data);

        setPhysicianDropdownData(parsedData);


        setLoading(false);
      })

      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };


  const handleSelectChange = (e) => {
    const { value } = e.target;
    setSelectedServicelocation(value);
    const allSelected = tableDetails.every((_, index) =>
      selectedLocationRows.includes(index)
    );
    for (const curIndex of selectedLocationRows) {
      const item = tableDetails[curIndex];
      item.ServiceLocationCode = value;
    }
  };

  const handlePracticeButtonClick = (item) => {
    setSelectedCMS33a(item.NPI);
    setSelectedBillingNPI(item.NPI);
    const matchedTaxonomy = practiceTaxonomycodes.find(
      (tax) => tax.PracticeLabel === item.PracticeLabel
    );
    if (matchedTaxonomy) {
      setSelectedCMS33b(matchedTaxonomy.Taxonomycode);
    }
  };

  const handleSelectBillingNPI = (event) => {
    const selectedValue = event.target.value;
    setSelectedBillingNPI(selectedValue);
  };

  const bindPatallclaims = () => {
    setShowButtons(false);
  };

  const filteredProviders = practiceProvider?.filter(
    (provider) => provider.Supervisor === "1" || provider.Supervisor === "3"
  );



  const handleSelectFilterProviders = (event) => {
    const selectedValue = event.target.value;
    setSelectedFilterProvider(selectedValue);
  };

  const handleFromDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "MM/dd/yyyy");
      setStartDate(formattedDate);
    } else {
      setStartDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "MM/dd/yyyy");
      setEndDate(formattedDate);
    } else {
      setEndDate(null);
    }
  };


  const handleCheckboxClick = (rowId) => {
    setIsCheckboxChecked(prev => ({
      ...prev,
      [rowId]: !prev[rowId]
    }));
  };


  const handleToApproveDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "MM/dd/yyyy");
      setApproveDate(formattedDate);
    } else {
      setApproveDate(null);
    }
  };

  const handleCloseModals = () => {
    // Close all modals
    setErrorMessage("");
    setShowPaidErrorModal(false);
    setShowSuccessModal(false);
    setShowEncModal(false);
    setErrorMessage(false);
    setShowErrorModal(false);
    setShowUploadModal(false);
    setShowDeleteModal(false);
    setSuccessDeleteModal(false);
    setShowValidationModal(false);

  };

  const getClaimStatusData = () => {
    const objInput = {
      iPracticeID: userPracticeID + "",
      sFromDate: "01/01/2023",
      sToDate: "01/01/2023",
      sFilterType: "",
      sPatientID: "",
      sInsuranceID: "",
      sCPT: "",
      sInsorPatFilter: "claimID",
      sLocationID: 0,
      sFilterText: id,
      ViewType: 0,
      isClosedClaims: true,
      sService: [],
      sCPTGroups: [],
      sClaimStatus: "",
      sDefaultSearch: false,
      roleID: userData.roleID,
      iProviderTemplateID: userData.iProviderTemplateID,
      DefaultTimeZoneOffSet: userData.DefaultTimeZoneOffSet
    };




    var myInput = JSON.stringify({ ObjClaims: objInput });
    // console.log("input of" + ClaimStatusConstants.GetClaimStatusData, myInput);


    const url = `${APIConstants.BASE_URL_BILLING}${ClaimStatusConstants.GetClaimStatusData}?sInputJSON=${myInput}`;

    // console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })


      .then(data => {


        const parsedTableData = JSON.parse(data);
        const tableData = parsedTableData?.Data[0];
        setClaimRowsData(tableData);
        console.log("ClaimData:", tableData);


        setClaimDetails(tableData[0]);
        setBtnStatus(tableData[0]?.Status);
        setDenied(tableData[0]?.isDenied);
        setSelectedCPTServiceID(tableData[0]?.CPTServiceID);
        setSelectedPatientID(tableData[0].PatientID);
      })
      .catch((error) => {
        setError("API request failed");
        setLoading(false);
      });
  };


  useEffect(() => {
    if (searchPatientText.trim() !== "") {
      fetchSuggestionPatientNames();
    } else {
      setSearchPatientData([]);
    }
  }, [searchPatientText]);


  const formatInsDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    // Hide 1/1/1900 or equivalent formats
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    if (year === 1900 && month === 1 && day === 1) {
      return "";
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };


  const fetchSearchCPTListByRow = (index, searchKey) => {

    const inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: searchKey,
    };

    const sJSONInput = JSON.stringify(inputJSON);
    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllCPTList}?sInputJSON=${sJSONInput}`;
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${sAuthToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const cptData = JSON.parse(data);
        const updatedRows = [...rows];
        updatedRows[index].selectedCPTs = cptData?.filter(
          (item) => `${item.CPTCode} ${item.CPTDesc}` !== searchKey
        );
        setRows(updatedRows);
      })
      .catch((error) => {
        console.error("Error fetching CPT names:", error);
      });
  };



  const fetchAllMacroData = async (macroName) => {
    try {
      const inputJSON = {
        PracticeID: userPracticeID,
        MacroName: macroName,
      };

      const sJSONInput = JSON.stringify(inputJSON);
      const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetAllMacroDetails}?sInputJSON=${sJSONInput}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${sAuthToken}`,
        },
      });

      if (!response.ok) {
        console.error(`Error: ${response.status}`);
        return null; // Handle error gracefully
      }

      const data = await response.json();
      const parsedData = JSON.parse(data);

      return parsedData;
    } catch (error) {
      console.error("Error fetching macro data:", error);
      return null;
    }
  };

  const fetchModList = (value, index) => {
    const inputStruct = {
      modName: value,
    };

    const myInput = { sInputJSON: JSON.stringify(inputStruct) };
    const myInputData = JSON.stringify(myInput);

    fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: myInputData,
    })
      .then((response) => response.json())
      .then((data) => {
        const parsedData = JSON.parse(data.d);
        const modData = parsedData.Data;

        if (Array.isArray(modData)) {
          const updatedRows = [...rows];
          updatedRows[index].modDataList = modData.map((item) => {
            if (item && typeof item === "object" && "Value" in item) {
              return {
                val: item.Value.split(" | ")[0],
              };
            } else {
              console.error("Invalid item in modData:", item);
              return null;
            }
          });
          setRows(updatedRows);
        }
      })
      .catch((error) => {
        console.error("Error fetching Mod names:", error);
      });
  };




  const GenerateNewClaims = async () => {

    if (!validateDocuments()) {

      return;
    }
    let errorMessage = "";

    if (!isCheckboxChecked && id) {
      errorMessage += "Please select the one checkbox.\n";
    }

    if (iClaimPriIns != selectedInsurance) {
      const sResubmitablecode = selectedResubmitCode;
    }

    if (
      selectedInsurance === "-1" ||
      selectedInsurance <= 0 ||
      selectedInsurance === null
    ) {
      errorMessage += "Please select primary insurance\n";
    }

    if (
      selectedBillingNPI === undefined ||
      selectedBillingNPI === "" ||
      selectedBillingNPI <= 0 ||
      selectedBillingNPI === null
    ) {
      errorMessage += "Please select service location NPI.";
    }
    if (
      selectedCMS33a === undefined ||
      selectedCMS33a === "" ||
      selectedCMS33a <= 0 ||
      selectedCMS33a === null
    ) {
      errorMessage += "Please billing provider NPI. \n";
    }
    if (
      selectedCMS33b === undefined ||
      selectedCMS33b === "" ||
      selectedCMS33b <= 0 ||
      selectedCMS33b === null
    ) {
      errorMessage += "Please select provider taxonomy code.\n";
    }
    if (
      selectedRenderingProvider === undefined ||
      selectedRenderingProvider === "" ||
      selectedRenderingProvider <= 0 ||
      selectedRenderingProvider === null
    ) {
      errorMessage += "Please select rendering provider.\n";
    }
    if (
      selectedLocation === "" ||
      selectedLocation <= 0 ||
      selectedLocation === null
    ) {
      errorMessage += "Please select place of service.\n";
    }
    if (
      selectedServiceLocation === "" ||
      selectedServiceLocation <= 0 ||
      selectedServiceLocation === null
    ) {
      errorMessage += "Please select ServiceLocation 24B.\n";
    }


    if (!appointmentDate) {
      errorMessage += "Please select Appointment Date.";
    }


    // console.log(errorMessage);

    if (errorMessage) {
      setErrorMessage(errorMessage);
      return;
    }

    setErrorMessage(errorMessage);



    const formatAppointDate = appointmentDate
      ? convertDateFormat(appointmentDate)
      : new Date().toLocaleDateString("en-US");
    // console.log("appointmentDate", formatAppointDate);

    const formatStartDate = startDate
      ? convertDateFormat(startDate)
      : new Date().toLocaleDateString("en-US");
    const formatEndDate = endDate
      ? convertDateFormat(endDate)
      : new Date().toLocaleDateString("en-US");
    const formatApproveDate = approveDate
      ? convertDateFormat(approveDate)
      : new Date().toLocaleDateString("en-US");

    var PatientPrimaryinsuranceID = patientInsData?.insuranceValue;

    var iClaimPriIns = patientInsData?.insid;
    // console.log("PatientPrimaryinsuranceID", PatientPrimaryinsuranceID);

    PatientPrimaryinsuranceID = PatientPrimaryinsuranceID?.split("_")[0];
    const sResubmitablecode = selectedResubmitCode;

    var ClaimLineItems = [];
    let ClaimArray = [];
    var objClaimAllDetails;



    if (errorMessage === "") {
      let hasDiagValue = false;


      let filteredRows = [];

      if (isCheckboxChecked) {
        filteredRows = rows.filter(row => isCheckboxChecked[row.ID]);
      } else {
        filteredRows = rows;
      }


      for (const item of filteredRows) {
        if (item?.diag1 || item?.diag2 || item?.diag3 || item?.diag4) {
          hasDiagValue = true;
          break;
        }
      }

      if (!hasDiagValue) {
        errorMessage += "Add at least 1 Diag value.\n";
        setErrorMessage(errorMessage);
        return;
      }

      const ClaimLineItems = filteredRows.map((row) => ({
        CPTcode: row?.procedure,
        Modifier: row?.mod1,
        Modifier2: row?.mod2,
        Modifier3: row?.mod3,
        ICD1: row?.diag1?.split(' - ')[0] || '',
        ICD2: row?.diag2?.split(' - ')[0] || '',
        ICD3: row?.diag3?.split(' - ')[0] || '',
        ICD4: row?.diag4?.split(' - ')[0] || '',
        Unit: row?.unit,
        UnitCharges: row?.unitCharge,
        CPTServiceID: row?.CPTServiceID ?? '',
        Claim24B: selectedServiceLocation !== undefined ? selectedServiceLocation : "",
      }));


      const curDOS = formatDOSDate(claimDetails?.ClaimDOS);


      var SupervisorProviderfornewclaim = selectedFilterProvider !== undefined ? selectedFilterProvider : "0";
      if (SupervisorProviderfornewclaim === '') {
        SupervisorProviderfornewclaim = "0";
      }



      var objclaimInput = {

        PracticeID:
          userData.practiceID !== undefined ? userData.practiceID : "",
        PatientID:
          claimDetails.PatientID !== undefined
            ? claimDetails.PatientID
            : selectedInsurance.PatientID,
        DOS: appointmentDate ?? curDOS ?? "",
        ProviderID:
          selectedRenderingProvider !== undefined
            ? selectedRenderingProvider
            : "",
        SchedulingProviderID: selectedPracticeProvider,
        SupervisorIndicator: selectedProvidersCategory,
        SupervisorProviderID: SupervisorProviderfornewclaim,
        Insurance: selectedInsurance.InsCoID ?? selectedInsurance.insCoID,
        PolicyNumber: selectedInsurance.insPolicyNumber ?? selectedInsurance.InsPolicyNumber,
        Claim24B: selectedServiceLocation !== undefined ? selectedServiceLocation : "",

        Claim32A: selectedBillingNPI !== undefined ? selectedBillingNPI : "",
        Claim33A: selectedCMS33a !== undefined ? selectedCMS33a : "",
        Claim33B: selectedCMS33b !== undefined ? selectedCMS33b : "",
        PlaceofService: selectedLocation !== undefined
          ? selectedLocation
          : "",
        SkipBox32: isBOX32checked,
        UserID: userData.userID,
        RoleID: userData.roleID,
        IsClaimSplit: false,
        IsScheduleAppointment: true,
        IsPrimarySkipped: isPrimarySkipped,
        PatientSecInsurance: selectedSecInsurance?.insCoID ?? selectedSecInsurance?.InsCoID,
        PatientSecInsurancePolicy: selectedSecInsurance?.insPolicyNumber ?? selectedSecInsurance?.InsPolicyNumber,
        PageModule: 'Newenc',
        ClaimENote: claimNotes ?? "",

        objCPTDetails: ClaimLineItems,

      };



      ClaimArray.push(objclaimInput);

      var myInput = JSON.stringify({ objClaim: ClaimArray });
      var myInputData = JSON.stringify(myInput);
      // console.log("Input of " + NewEncounterConstants.GenerateNewClaim, myInputData);


      const response = await fetch(
        APIConstants.BASE_URL_BILLING + NewEncounterConstants.GenerateNewClaim,
        {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${sAuthToken}`
          },
          body: myInputData,
        }
      );

      try {
        const responseData = await response.json();

        console.log("Response of " + NewEncounterConstants.GenerateNewClaim, responseData);
        setisLoading(false);

        if (responseData > 0) {
          setSelectedClaimID(responseData);
          setShowSuccessModal(true);

          const url = `/#/Claimapproval`;
          window.open(url, "_blank");
          //refreshPage();
        }


      } catch (error) {
        console.error("Error fetching data: ", error);
        setisLoading(false);
      }

    }
  };


  const handleSecIns = () => {
    if (selectedSecInsurance) {
      checkEligibility()
    }
  }


  const fetchDiagListByRow = (diag1Value, index) => {
    var inputStruct = {
      icdName: diag1Value,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetIcdList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const parsedData = JSON.parse(data.d);
        const diagData = parsedData.Data;
        const updatedRows = [...rows];
        updatedRows[index].diagDataList = diagData;
        setRows(updatedRows);
      })
      .catch((error) => {
        console.error("Error fetching ICD names:", error);
      });
  };

  // console.log("ClaimData", claimDetails);


  const handleSecInsuranceChange = (e) => {
    if (e.target.value === "-1") {
      setselectedSecInsurance("");
      return;
    }

    const selectedInsurance = patientSecInsData.find(
      (insurance) =>
        insurance.insCoID === e.target.value ||
        insurance.InsCoID === e.target.value ||
        insurance.InsCoName === e.target.value
    );


    if (selectedInsurance) {
      setselectedSecInsurance(selectedInsurance);
    } else {

    }
  };


  const SaveSecondaryClaim = () => {
    var SecInsurance = selectedSecInsurance;
    // SecInsurance = SecInsurance.split("_")[0];

    var SecInsPolicy = "";
    var PatientID = patientInsData.patientid;

    var ClaimID = id;

    var PatientPrimaryinsuranceID = selectedInsurance;

    PatientPrimaryinsuranceID = PatientPrimaryinsuranceID;

    if (SecInsurance != "" && SecInsurance != -1 && SecInsurance != 0) {
      // if (PatientPrimaryinsuranceID == SecInsurance) {
      //     setErrorMessage("Primary and secondary insurances can not be same");

      // }
      {


        const ClaimLineItems = filteredRows.map((row) => ({
          CPTCode: row?.procedure,
          Modifier: row?.mod1,
          Modifier2: row?.mod2,
          Modifier3: row?.mod3,
          ICD1: row?.diag1?.split(' - ')[0] || '',
          ICD2: row?.diag2?.split(' - ')[0] || '',
          ICD3: row?.diag3?.split(' - ')[0] || '',
          ICD4: row?.diag4?.split(' - ')[0] || '',
          Claim24B: selectedServiceLocation !== undefined ? selectedServiceLocation : "",
        }));


        const curDOS = formatDOSDate(claimDetails?.ClaimDOS);


        var SupervisorProviderfornewclaim = selectedFilterProvider !== undefined ? selectedFilterProvider : "0";
        if (SupervisorProviderfornewclaim === '') {
          SupervisorProviderfornewclaim = "0";
        }




        var objClaim = {
          ClaimID: id,
          PatientSecInsurance: selectedSecInsurance?.InsCoID,
          PatientSecInsurancePolicy: selectedSecInsurance?.InsPolicyNumber,
          DOS: appointmentDate ?? curDOS ?? "",
          PatientID: claimDetails?.PatientID ?? "",
          PracticeID: userPracticeID,
          UpdatedBy: claimDetails?.updatedby,
          Claim32A: selectedBillingNPI !== undefined ? selectedBillingNPI : "",
          Claim33A: selectedCMS33a !== undefined ? selectedCMS33a : "",
          Claim33B: selectedCMS33b !== undefined ? selectedCMS33b : "",
          SupervisorIndicator: selectedProvidersCategory,
          SupervisorProviderID: SupervisorProviderfornewclaim,
          ProviderID: selectedRenderingProvider !== undefined
            ? selectedRenderingProvider
            : "",
          Claim24B: selectedServiceLocation !== undefined ? selectedServiceLocation : "",
          ClaimENote: claimNotes ?? "",
          PriorAuthority: priorAuthority ?? "",
          objCPTDetails: ClaimLineItems,


        }



        var myInput = JSON.stringify({ objClaim: objClaim });
        var myInputData = JSON.stringify(myInput);

        fetch(
          APIConstants.BASE_URL_BILLING + NewEncounterConstants.SaveSecondaryClaim,
          {
            method: "POST",

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              'Authorization': `Bearer ${sAuthToken}`

            },

            body: myInputData,
          }
        )

          .then((response) => {

            if (response.status === 200) {
              setShowSuccessModal(true);
              const url = `/#/Claimapproval`;
              window.open(url, "_blank");


            }
          })
          .catch((error) => {
            setError("API request failed");
            setLoading(false);
          });
      }
    } else {
      setErrorMessage("Please select secondary insurance");
    }
  };
  //getting patient list
  const fetchSuggestionPatientNames = () => {
    // setSelectCptVal("");
    // setmacroDataList([]);

    var inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: searchPatientText,
      SearchBy: 0,
      isFromLogin: 0,
    };

    var sJSONInput = JSON.stringify(inputJSON);
    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
        } else return response.json();
      })
      .then((data) => {
        const parsedData = JSON.parse(data);

        const patientData = parsedData.Data;

        if (Array.isArray(patientData)) {
          setSearchPatientData(
            patientData.map((item) => ({
              label: `${item.LastName}, ${item.FirstName}`,
              val: item.PatientID,
              dob: item.DOB,
            }))
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching patient names:", error);
      });
  };
  const handleRoleChange = (event) => {
    const role = event.target.value;
    setSelectedRole(role);
    setSelectedCertification(""); // Reset certification
    setProviders([]); // Reset providers
  };

  // Handle certification selection
  const handleCertificationChange = (event) => {
    const certificationID = event.target.value;
    setSelectedCertification(certificationID);

    // Get the selected role's certifications
    const roleData = practiceProvider[selectedRole].find(
      (group) => group.CertificaionID === certificationID
    );

    // Update providers based on the selected certification
    setProviders(roleData?.objProviderList || []);
  };
  const handleInsuranceChange = (e) => {
    setisInsdata(false);
    if (e.target.value === "-1") {
      setSelectedInsurance("");
      return;
    }
    patientInsData.find((insurance) => {
      if (
        insurance.insCoID === e.target.value ||
        insurance.InsCoID === e.target.value
      ) {
        setSelectedPatientInsurance(insurance?.InsPolicyNumber);


        setSelectedInsurance(insurance);
        if (insurance?.PatInsStatus === 1) {
          setShowEligible(true);
        }
        if (insurance?.PatInsStatus === 2) {
          setShowSecondaryEligible(true);
        }
      }
      return (
        insurance.insCoID === e.target.value ||
        insurance.InsCoID === e.target.value
      );
    });
  };




  useEffect(() => {
    if (selectedInsurance === "") {

      setSelectedInsurance("");
      setSelectedPatientInsurance("");
    }
    else if (selectedInsurance && Object.keys(selectedInsurance).length > 0) {

      setSelectedPatientInsurance(selectedInsurance.InsPolicyNumber || "");
    }
    else if (patientInsData?.length > 0) {

      const defaultInsurance = patientInsData.find(
        (ins) => ins.PatInsStatus == 1
      );

      if (defaultInsurance) {
        setSelectedInsurance(defaultInsurance);
        setSelectedPatientInsurance(defaultInsurance.InsPolicyNumber || "");
      }
    }
  }, [patientInsData, selectedInsurance]);




  useEffect(() => {
    if (claimRowsData?.length > 0) {
      addClaimDetailsToRows();

    }
  }, [claimRowsData]);



  const handleCptChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].procedure = value;

    updatedRows[index].hideList = value.trim() !== "";

    setRows(updatedRows);

    if (value.trim() !== "") {
      fetchSearchCPTListByRow(index, value);
    }
  };



  const saveCpt = async (index, value) => {
    const updatedRows = [...rows];
    if (value?.GrpName !== "macro") {
      updatedRows[index].procedure = value?.CPTCode;
      updatedRows[index].unit = 1;
      updatedRows[index].unitCharge = value?.UnitCharge;

      const units = 1;
      const unitCharge = parseFloat(value?.UnitCharge || 0);
      const totalCharge = units * unitCharge
      updatedRows[index].totalCharge = parseFloat(totalCharge).toFixed(2);
      updatedRows[index].hideList = false;


      setSelectedCPTServiceID(value?.CPTServiceID)

    } else {
      try {
        const response = await fetchAllMacroData(value?.CPTCode);

        response.forEach((element, idx) => {
          if (!updatedRows[index + idx]) {
            updatedRows[index + idx] = { ...updatedRows[index] };
          }
          updatedRows[index + idx].procedure = element?.CPT;
          updatedRows[index + idx].unit = element?.Units;
          updatedRows[index + idx].totalCharge = element?.TotalCharge;
          updatedRows[index + idx].unitCharge =
            element?.UnitCharge && Number(element?.UnitCharge);
          updatedRows[index + idx].hideList = false;
          updatedRows[index + idx].mod1 = element?.Mod1;
          updatedRows[index + idx].mod2 = element?.Mod2;
          updatedRows[index + idx].mod3 = element?.Mod3;
          updatedRows[index + idx].diag1 = element?.Diag1;
          updatedRows[index + idx].diag2 = element?.Diag2;
          updatedRows[index + idx].diag3 = element?.Diag3;
          updatedRows[index + idx].diag4 = element?.Diag4;

        });
      } catch (error) {
        console.error("Error calling macro API:", error);
      }
    }



    setRows(updatedRows);
    updateGrandTotal();
  };

  const saveTableData = (index, key, value, hide) => {


    const updatedRows = [...rows];
    updatedRows[index][key] = value;
    if (hide) {
      updatedRows[index][hide] = false;
    }
    setRows(updatedRows);
  };



  const updateGrandTotal = () => {
    const total = rows.reduce((sum, row) => {
      if (row.IsCPTMoved !== 1) {
        return sum + (parseFloat(row.totalCharge) || 0);
      }
      return sum;
    }, 0);

    setGrandTotal(total.toFixed(2));
  };


  useEffect(() => {
    updateGrandTotal()

  }, [grandTotal])



  const suggestionRefs = useRef({});



  useEffect(() => {
    const handleClickOutside = (event) => {
      const updatedRows = [...rows];
      let modified = false;

      rows.forEach((row, index) => {
        const container = suggestionRefs.current[index];

        if (container && !container.contains(event.target)) {
          if (row.hideList || row.hideMod || row.hideMod1 || row.hideMod2 || row.hideDiag || row.hideDiag1 || row.hideDiag2 || row.hideDiag3) {
            updatedRows[index].hideList = false;
            updatedRows[index].hideMod = false;
            updatedRows[index].hideMod1 = false;
            updatedRows[index].hideMod2 = false;
            updatedRows[index].hideDiag = false;
            updatedRows[index].hideDiag1 = false;
            updatedRows[index].hideDiag2 = false;
            updatedRows[index].hideDiag3 = false;
            modified = true;
          }
        }
      });

      if (modified) setRows(updatedRows);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [rows]);







  const handleDiagChange = (value, key, index, hide) => {
    const updatedRows = [...rows];

    updatedRows[index][key] = value;


    updatedRows[index][hide] = value.trim() !== "";

    setRows(updatedRows);


    if (value.trim() !== "") {
      fetchDiagListByRow(value, index);
    }
  };



  const handleModChange = (value, key, index, hide) => {
    const updatedRows = [...rows];

    updatedRows[index][key] = value;
    updatedRows[index][hide] = true;


    if (value === "") {
      updatedRows[index][key] = "";
      updatedRows[index][hide] = false;
    }

    setRows(updatedRows);

    if (value !== "") {
      fetchModList(value, index);
    }
  };



  const checkEligibility = () => {


    const requestBody = {
      objPatientDetails: {
        PatientID: selectedPatientId,
        PolicyNumber: selectedSecInsurance?.InsPolicyNumber,
        InsCompanyID: selectedSecInsurance?.InsCoID,
        PracticeID: userPracticeID,
        RowIndex: 0,
        DOS: appointmentDate ? appointmentDate : formatDOSDate(new Date())
      },
    };


    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientEligibility}?sInputJSON=${encodeURIComponent(JSON.stringify(requestBody))}`;
    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .catch(() => {
      });
  };

  const addClaimDetailsToRows = () => {
    const newRows = claimRowsData.map((detail) => ({
      fromDate: formatDOSDate(detail?.DOS),
      toDate: formatDOSDate(detail?.DOS),
      ClaimId: detail?.ClaimId,
      providername: detail?.providername,
      procedure: detail.ClaimCPT,
      mod1: detail.Mod1,
      mod2: detail.Mod2,
      mod3: detail.Mod3,
      diag1: detail.Diag1,
      diag2: detail.Diag2,
      diag3: detail.Diag3,
      diag4: detail.Diag4,
      unit: detail?.Units,
      unitCharge: detail?.UnitCharge,
      totalCharge: detail?.totalcharge,
      recvdCharge: detail?.recvdCharge,
      SecrecvdCharge: detail?.SecrecvdCharge,
      Adjustment: detail?.Adjustment,
      SecPendingAmt: detail?.SecPendingAmt,
      Deductible: detail?.Deductible,
      PatientAmount: detail?.PatientAmount,
      AdminWriteOff: detail?.AdminWriteOff,
      ClaimCPTLineNumber: detail?.ClaimCPTLineNumber,
      FederalReduction: detail?.FederalReduction,
      CPTServiceID: detail?.CPTServiceID,
      ID: detail?.ID,
      IsCPTMoved: detail?.IsCPTMoved
    }));
    setRows(newRows);
  };


  const AddNewCPTtoClaims = () => {
    if (errorMessage === "") {
      var arrClaimNewCPTDetails = [];
      var arrClaimOldCPTDetails = [];

      arrClaimNewCPTDetails = rows?.map((row, index) => ({

      }));

      var objClaim = {
        // PatientID: claimData.PatientID,
        ClaimID: id,
        UpdatedBy: userData.userID,
        // PracticeID: claimData.practiceId,
        DOS: formatDOSDate,
      };

      var inputStruct = {
        objClaim: objClaim,
        arrClaimNewCPTDetails: arrClaimNewCPTDetails,
        arrClaimOldCPTDetails: arrClaimOldCPTDetails,
        LoggedInUserDetails: userData,
      };

      var myInput = { sInputJSON: JSON.stringify(inputStruct) };
      myInput = JSON.stringify(myInput);
      fetch(APIConstants.BASE_URL + NewEncounterConstants.AddNewCPTtoClaims, {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInput,
      })
        .then((response) => response.json())
        .then((data) => {
          const responsedData = JSON.parse(data.d);
          if (responsedData.Status == "Success") {
            setShowSuccessModal(true);
            const url = `/#/Claimapproval`;
            window.open(url, "_blank");
          }
        })

        .catch((error) => {
          setError("API request failed");
          setLoading(false);
        });
    }
  };





  const GetProviderPDF = (item) => {

    const claimFilters = {
      PracticeID: userPracticeID,
      PatientID: item.PatientID,
      DOS: formatDOSDate(item.ClaimDOS),
      CPT: item.CPTOld
    };


    const sInputJSON = JSON.stringify({ objPatDetails: claimFilters });

    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.CPTDcoument}?sInputJSON=${sInputJSON}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`,
      }
    })

      .then(response => response.json()) // Parse the response as JSON
      .then(data => {


        const url = JSON.parse(data);
        window.open(url.DocumentURL, '_blank');


      })
      .catch(error => {
        console.error(' PDF failed', error);
      });
  };



  const UpdateBtnclick = () => {
    if (!validateDocuments()) {

      return;
    }


    if (claimDetails.Status === "1" && claimDetails.isDenied === "0") {
      AddNewCPTtoClaims();
    } else {
      if (claimDetails.isDenied == 1) {
        var PatientPrimaryinsuranceID = claimDetails?.InsuID;
        var iClaimPriIns = patientInsData[0]?.insCoID;

        /*var PatientPrimaryinsuranceID = patientInsData.insuranceValue;
        var iClaimPriIns = patientInsData.insid;
        PatientPrimaryinsuranceID = PatientPrimaryinsuranceID.split("_")[0];*/
        var sResubmitablecode = selectedResubmitCode;
        if (iClaimPriIns != PatientPrimaryinsuranceID) {
          sResubmitablecode = "0";
        } else {
          if (sResubmitablecode == 0 || sResubmitablecode == "") {
            setErrorMessage("Resubmission code is invalid");
            return;
          } else if (selectedOriginalClaim === "") {
            setErrorMessage("Original claim number is invalid");
            return;
          }
        }
      }
    }

    UpdateClaimDetails();
  };



  useEffect(() => {
    if (claimRowsData?.length > 0) {


      updateGrandTotal()
    }
  }, [claimRowsData, rows]);

  const UpdateClaimDetails = () => {

    const formatAppointDate = appointmentDate
      ? convertDateFormat(appointmentDate)
      : new Date().toLocaleDateString("en-US");

    const formatStartDate = startDate
      ? convertDateFormat(startDate)
      : new Date().toLocaleDateString("en-US");
    const formatEndDate = endDate
      ? convertDateFormat(endDate)
      : new Date().toLocaleDateString("en-US");
    const formatApproveDate = approveDate
      ? convertDateFormat(approveDate)
      : new Date().toLocaleDateString("en-US");
    // let formatAppointDate, formatStartDate, formatEndDate, formatApproveDate;
    var skipBox32 = 0;
    var PatientPrimaryinsuranceID = claimDetails?.InsuID;
    var iClaimPriIns = Array.isArray(patientInsData) && patientInsData.length > 0
      ? patientInsData[0].insCoID ?? ""
      : "";

    //PatientPrimaryinsuranceID = PatientPrimaryinsuranceID?.split("_")[0] ?? "";
    var dblClaimTotal = 0;
    var curtotalcharge = 0;
    if (!isNaN(rows?.totalCharge))
      curtotalcharge = parseFloat(rows?.totalCharge);
    var dblClaimTotal = parseFloat(dblClaimTotal) + parseFloat(curtotalcharge);
    //if claim is rejected for billing to wrong insurance then ignore the resubmission details
    let sResubmitablecode = selectedResubmitCode;
    let errorMessage = "";
    if (iClaimPriIns != PatientPrimaryinsuranceID) {
      sResubmitablecode = "0";
    }
    if (
      selectedBillingNPI === "" ||
      selectedBillingNPI <= 0 ||
      selectedBillingNPI == null
    ) {
      errorMessage += "Please select service location NPI.";
    }
    if (
      selectedLocation === "" ||
      selectedLocation <= 0 ||
      selectedLocation == null
    ) {
      errorMessage += "Please select service location Address.";
    }
    if (
      selectedCMS33a === "" ||
      selectedCMS33a <= 0 ||
      selectedCMS33a == null
    ) {
      errorMessage += "Please billing provider NPI. \n";
    }
    if (
      selectedCMS33b === "" ||
      selectedCMS33b <= 0 ||
      selectedCMS33b == null
    ) {
      errorMessage += "Please select billing provider taxonomy code.";
    }
    if (
      selectedRenderingProvider === "" ||
      selectedRenderingProvider <= 0 ||
      selectedRenderingProvider == null
    ) {
      errorMessage += "Please select rendering provider.";
    }
    if (
      selectedPracticeProvider === "" ||
      selectedPracticeProvider <= 0 ||
      selectedPracticeProvider == null
    ) {
      errorMessage += "Please select scheduling Provider.";
    }
    setErrorMessage(errorMessage);


    if (errorMessage === "") {
      var arrClaimDetails = [];



      if (rows && rows.length > 0) {
        arrClaimDetails = rows.map((row, index) => ({

          PatientId: claimDetails?.PatientID,
          From: formatStartDates[index] !== undefined
            ? formatStartDates[index] + ""
            : "",
          To:
            formatToDates[index] !== undefined ? formatToDates[index] + "" : "",
          CPTCode: row?.procedure,
          Modifier: row?.mod1,
          Modifier2: row?.mod2,
          Modifier3: row?.mod3,
          ICD1: row?.diag1,
          ICD2: row?.diag2,
          ICD3: row?.diag3,
          ICD4: row?.diag4,
          Unit: row?.unit,
          UnitCharges: row?.unitCharge,
          CPTLineNumber: row?.ClaimCPTLineNumber,
          CPTServiceID: row?.CPTServiceID ?? '',
          RowID: row?.ID,
          Claim24B: selectedServiceLocation !== undefined ? selectedServiceLocation : "",

        }));
      } else {
        // arrClaimDetails.push(CurRowItems);
      }
      var dblClaimTotal =
        parseFloat(dblClaimTotal) + parseFloat(curtotalcharge);

      var ClaimType = 1;

      const curAppointMentdate = formatDOSDate(appointmentDate);

      var objClaim = {
        PracticeID: userData.practiceID,
        PatientID: claimDetails?.PatientID,
        ProviderID: selectedRenderingProvider.toString(),
        DOS: formatAppointDate || curAppointMentdate,
        SupervisorProviderID: selectedFilterProvider,
        SupervisorIndicator: (selectedProvidersCategory != null && selectedProvidersCategory != "") ? selectedProvidersCategory : "-1",
        SkipBox32: skipBox32,
        Insurance: PatientPrimaryinsuranceID,
        PolicyNumber: patientInsData[0]?.InsPolicyNumber,
        Claim24B: selectedServiceLocation !== undefined ? selectedServiceLocation : "",
        Claim32A: selectedBillingNPI,
        Claim33A: selectedCMS33a,
        Claim33B: selectedCMS33b,
        PlaceofService: selectedLocation,
        UserID: userData.userID,
        RoleID: userData.roleID,
        ClaimID: id.toString(),
        IsClaimSplit: 0,
        SchedulingProviderID: selectedPracticeProvider,
        TimeZoneOffSet: userData.TimeZoneOffSet,
        ResubmitCode: selectedResubmitCode != null ? selectedResubmitCode : "0",
        PayerClaimRefNumber: selectedOriginalClaim,
        IsPrimarySkipped: isPrimarySkipped,
        PatientSecInsurance: selectedSecInsurance?.insCoID ?? selectedSecInsurance?.InsCoID,
        PatientSecInsurancePolicy: selectedSecInsurance?.insPolicyNumber ?? selectedSecInsurance?.InsPolicyNumber,
        ClaimENote: claimNotes ?? "",
        PriorAuthority: priorAuthority ?? "",
        objCPTDetails: arrClaimDetails
      };

      var inputStruct = {
        objClaim: objClaim,
      };

      // var myInput = { JSON.stringify(inputStruct) };
      var myInputData = JSON.stringify(JSON.stringify(inputStruct));

      const url = `${APIConstants.BASE_URL_BILLING}${NewEncounterConstants.UpdateClaimDetails}`;

      const response = fetch(url,
        {
          method: "POST",

          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sAuthToken}`
          },

          body: myInputData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const responsedData = data;

          // console.log("Response of" + NewEncounterConstants.UpdateClaimDetails, responsedData);

          if (responsedData > 0) {
            setShowSuccessModal(true);
            const url = `/#/Claimapproval`;
            window.open(url, "_blank");
            handleUploadClaimAttachments()

          }
        })

        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace") {
      // Handle backspace key
      if (searchPatientText === "" && searchPatientData.length > 0) {
        setSearchPatientData([]);
      } else {
        fetchSuggestionPatientNames(searchPatientText.slice(0, -1)); // Remove the last character from searchText
      }
    } else {
      // Fetch suggestions only when the user types in the input field
      fetchSuggestionPatientNames(searchPatientText + e.key);
    }
  };


  const handlePatientSuggestion = (suggestion) => {


    const date = new Date(suggestion.dob);
    const formattedDate = date.toLocaleDateString();
    const fullLabel = suggestion.label;
    setSearchPatientText(fullLabel);
    setSelectedDOB(formattedDate);
    setIsPatientSelected(true);
    // setShowButtons(true);
    setSelectedPatientID(suggestion?.val);
    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatInsuranceDetails}?PatientId=${suggestion.val}`;
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${sAuthToken}`,
      },
    })
      .then((response) => {
        if (response.status != 200) {
        } else return response.json();
      })
      .then((data) => {
        const parsedData = JSON.parse(data);
        const filteredData = parsedData?.filter(
          (item) => item?.InsType === "1"
        );
        const filteredDataForSecIns = parsedData?.filter(
          (item) => item?.InsType === "2"
        );
        setPatientInsData(filteredData);

        setPatientSecInsData(filteredDataForSecIns);
        setSelectedInsurance(filteredData[0]);
        if (filteredData[0]?.PatInsStatus === 1) {
          setShowEligible(true);
        }
        if (filteredData[0]?.PatInsStatus === 2) {
          setShowSecondaryEligible(true);
        }
        setselectedSecInsurance(filteredDataForSecIns[0]);
        setSelectedPatientInsurance(
          filteredData && filteredData[0]?.InsPolicyNumber
        );
        // setSelectedSecPatientInsurance(
        //   filteredDataForSecIns && filteredDataForSecIns[0]?.InsPolicyNumber
        // );
      })
      .catch((error) => {
        console.error("Error fetching:", error);
      });
  };


  useEffect(() => {

    const claimDOS = formatDOSDate(claimDetails?.ClaimDOS);
    // console.log("INS TRiggered>>>>",claimDOS);
    const Dos = formatAppointMentDate(claimDetails?.AppointmentDate);
    var inputJSON = {
      DOS: claimDOS || Dos,
      PatientID: claimDetails?.PatientID || claimDetails?.PatientId,
    };
    var sInputJSON = JSON.stringify({ objIns: inputJSON });
    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientInsurance}?sInputJSON=${sInputJSON}`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${sAuthToken}`,
      },
    })
      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then((data) => {
        const parsedData = JSON.parse(data);

        setInsuranceData(parsedData)
        const filteredData = parsedData?.filter((item) => {
          return item?.InsType == 1;
        });
        const filteredDataForSecIns = parsedData?.filter(
          (item) => item?.InsType == 2
        );


        setPatientInsData(filteredData);

        setPatientSecInsData(filteredDataForSecIns);
        setSelectedInsurance(filteredData[0]);
        if (filteredData[0]?.PatInsStatus == 1) {
          setShowEligible(true);
        }
        if (filteredData[0]?.PatInsStatus == 2) {
          setShowSecondaryEligible(true);
        }
        setselectedSecInsurance(filteredDataForSecIns[0]);
        setSelectedPatientInsurance(
          filteredData && filteredData[0]?.insPolicyNumber
        );
      })
      .catch((error) => {
        console.error("Error fetching patient names:", error);
      });
    // }
  }, [claimDetails?.PatientID, claimDetails?.ClaimDOS, claimDetails]);

  useEffect(() => {
    setSelectedBillingNPI(claimDetails?.claim32a);
  }, [claimDetails?.claim32a]);

  useEffect(() => {
    setSelectedDOB(claimDetails?.PatDOB);
  }, [claimDetails]);

  useEffect(() => {
    setSelectedCMS33a(claimDetails?.claim33a);
  }, [claimDetails?.claim33a]);

  useEffect(() => {
    setSelectedCMS33b(claimDetails?.claim33b);
  }, [claimDetails?.claim33b]);

  useEffect(() => {
    setSelectedServicelocation(claimDetails?.ServiceLocationCode);
  }, [claimDetails?.ServiceLocationCode]);

  useEffect(() => {
    setSelectedRenderingProvider(claimDetails?.RenderingProvider);
  }, [claimDetails?.RenderingProvider]);

  var Box17Indicator = claimDetails?.Box17Indicator || "";

  useEffect(() => {
    var Box17Indicator = claimDetails?.Box17Indicator || "";

    setSelectedProvidersCategory(Box17Indicator);
  }, [Box17Indicator]);


  useEffect(() => {
    if (!selectedProvidersCategory) {
      getPracticeProvidersOnly();
      getPhysicianDropdown();
    }
  }, [selectedProvidersCategory]);



  useEffect(() => {
    setSelectedPracticeProvider(claimDetails?.SchedulingProvider);
  }, [claimDetails?.SchedulingProvider]);

  useEffect(() => {
    setSelectedResubmitCode(claimDetails?.ResubmitCode);
  }, [claimDetails?.ResubmitCode]);

  useEffect(() => {
    setSelectedResubmitCode("0");
  }, []);

  useEffect(() => {
    setSelectedLocation(claimDetails?.PlaceofService ?? "");
  }, [claimDetails?.PlaceofService]);





  useEffect(() => {
    if (
      claimDetails?.SupervisingProvider &&
      claimDetails?.SupervisingProvider !== "0"
    ) {
      setSelectedFilterProvider(claimDetails?.SupervisingProvider);
    } else {
      setSelectedFilterProvider("-1");
    }
  }, [claimDetails?.SupervisingProvider]);







  useEffect(() => {
    setSelectedOriginalClaim(claimDetails?.PayerRefNumber)
  }, [claimDetails?.PayerRefNumber]);


  useEffect(() => {

    if (selectedLocation === "") {
      setSelectedBillingAddress("<--Select-->");
    } else {
      const selectedLocationObject = locations.find(
        (location) => location.LocationId == selectedLocation
      );

      if (selectedLocationObject) {
        setSelectedBillingAddress(selectedLocationObject.LocationName);
      }
    }
  }, [selectedLocation, locations]);

  const handleNewEncounterClick = () => {
    window.open(`/#/patient-dashboard/${selectedPatientId}/primary-insurance`, '_blank');
  };

  const refreshPage = () => {

    navigate(0);
  };



  useEffect(() => {
    if (claimDetails?.ClaimDOS) {
      setAppointmentDate(formatDOSDate(claimDetails.ClaimDOS));
    }
  }, [claimDetails]);

  const handleToAppointmentDateChange = async (date) => {
    if (date) {
      const formattedDate = format(date, "MM/dd/yyyy");
      const formatted = new Date(date);
      const updatedData = await patientInsData?.filter((insurance) => {
        const endDate = new Date(insurance.endDate || insurance.EndDate);
        const startDate = new Date(insurance.startDate || insurance.StartDate);
        return formatted >= startDate && formatted <= endDate;
      });
      if (updatedData?.length === 0) {
        console.log("No insurance found with specified appointment date");
      } else {
        setPatientInsData(updatedData);
        setSelectedInsurance(updatedData[0]);
      }

      const CurrDate = new Date();
      const FormattedCurrDate = formatDOSDate(CurrDate);
      setAppointmentDate(formattedDate);
      setApproveDate(FormattedCurrDate);
      setStartDate(formattedDate);
      setEndDate(formattedDate);
      setFromDate(formattedDate);
      setToDate(formattedDate);
      setFromDates((prevFromDates) => prevFromDates.map(() => formattedDate));
      setToDates((prevToDates) => prevToDates.map(() => formattedDate));
      setRows((prev) =>
        prev.map((row) => ({
          ...row,
          fromDate: formattedDate,
          toDate: formattedDate,
        }))
      );

    } else {
      setAppointmentDate(null);
    }
  };



  const handleButtonClick = () => {
    setIsPrimarySkipped(true);

  };

  const getRowClass = (rowData) => {
    if (rowData?.recvdCharge > 0 || rowData?.IsCPTMoved == 1) {
      return "table-secondary";
    }
    return "table-primary";
  };


  // useEffect(() => {
  //   console.log(isPrimarySkipped);
  // }, [isPrimarySkipped]);
  const allZero = claimRowsData.every(
    (item) => item.recvdCharge == 0
  );
  const someZero = claimRowsData.some(
    (item) => item.recvdCharge == 0
  );
  const isPartiallyDenied = !allZero && someZero;
  const hasExistingClaim = id !== undefined && id !== null;
  useEffect(() => {
    if (isPartiallyDenied) {
      const checkedMap = {};
      claimRowsData.forEach((row) => {
        if (row.recvdCharge == 0) {
          checkedMap[row.ID] = true;
        }
      });
      setIsCheckboxChecked(checkedMap);
    }
  }, [isPartiallyDenied, claimRowsData]);


  const CorrectPartiallyDeniedClaim = async () => {
    const formatAppointDate = appointmentDate
      ? convertDateFormat(appointmentDate)
      : new Date().toLocaleDateString("en-US");
    const PatientPrimaryinsuranceID = claimDetails?.InsuID;
    const iClaimPriIns =
      Array.isArray(patientInsData) && patientInsData.length > 0
        ? patientInsData[0].insCoID ?? ""
        : "";
    let dblClaimTotal = 0;
    let curtotalcharge = 0;
    if (!isNaN(rows?.totalCharge)) curtotalcharge = parseFloat(rows?.totalCharge);
    dblClaimTotal = parseFloat(dblClaimTotal) + parseFloat(curtotalcharge);
    let sResubmitablecode = selectedResubmitCode;
    let errorMessage = "";
    if (iClaimPriIns != PatientPrimaryinsuranceID) {
      sResubmitablecode = "0";
    }
    if (!selectedBillingNPI) errorMessage += "Please select service location NPI.\n";
    if (!selectedLocation) errorMessage += "Please select service location Address.\n";
    if (!selectedCMS33a) errorMessage += "Please select billing provider NPI.\n";
    if (!selectedCMS33b) errorMessage += "Please select billing provider taxonomy code.\n";
    if (!selectedRenderingProvider) errorMessage += "Please select rendering provider.\n";
    if (!selectedPracticeProvider) errorMessage += "Please select scheduling Provider.\n";
    setErrorMessage(errorMessage);
    if (errorMessage !== "") return;
    const filteredRows = rows.filter(
      (row) => row.recvdCharge == null || parseFloat(row.recvdCharge) === 0
    );
    const arrClaimDetails = filteredRows.map((row, index) => ({
      PatientId: claimDetails?.PatientID,
      From: formatStartDates[index] ? formatStartDates[index] + "" : "",
      To: formatToDates[index] ? formatToDates[index] + "" : "",
      CPTCode: row?.procedure,
      Modifier: row?.mod1,
      Modifier2: row?.mod2,
      Modifier3: row?.mod3,
      ICD1: row?.diag1,
      ICD2: row?.diag2,
      ICD3: row?.diag3,
      ICD4: row?.diag4,
      Unit: row?.unit,
      UnitCharges: row?.unitCharge,
      CPTLineNumber: row?.ClaimCPTLineNumber,
      CPTServiceID: row?.CPTServiceID ?? "",
      RowID: row?.ID,
    }));
    dblClaimTotal = parseFloat(dblClaimTotal) + parseFloat(curtotalcharge);
    const curAppointMentdate = formatDOSDate(appointmentDate);
    const objClaim = {
      PracticeID: userData.practiceID,
      PatientID: claimDetails?.PatientID,
      DOS: formatAppointDate || curAppointMentdate,
      PrimaryInsurance: PatientPrimaryinsuranceID,
      ClaimID: id.toString(),
      ResubmitCode: selectedResubmitCode != null ? selectedResubmitCode : "0",
      PayerClaimRefNumber: selectedOriginalClaim,
      IsPrimarySkipped: isPrimarySkipped,
      ClaimENote: claimNotes ?? "",
      PriorAuthority: priorAuthority ?? "",
      PriorSec: 1,
    };
    const inputStruct = {
      objClaim,
      arrClaimDetails,
    };
    const myInputData = JSON.stringify(JSON.stringify(inputStruct));
    const url = `${APIConstants.BASE_URL_BILLING}${NewEncounterConstants.CorrectPartiallyDenied}`;
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${sAuthToken}`,
        },
        body: myInputData,
      });
      const data = await response.json();
      if (data > 0) {
        setShowSuccessModal(true);
        window.open("/#/Claimapproval", "_blank");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  useEffect(() => {
    if (selectedClaimID > 0) {
      handleUploadClaimAttachments();
    }
  }, [selectedClaimID]);


  const handleGetClaimAttachments = async () => {

    if (!id && !selectedClaimID) {
      setattachmentsData([]);
      return;
    }

    var objInput = {

      ClaimID: id || selectedClaimID,
      PracticeID: userData.practiceID,

    }

    var sInputJSON = JSON.stringify(objInput);


    const url = `${APIConstants.BASE_URL_BILLING}${NewEncounterConstants.GetClaimAttachments}?sInputJSON=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',

      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {
        console.log("Response Attachment", data);

        setattachmentsData(data);
      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }




  const handleGetPatientAllDocumentDetails = async () => {
    setdocAllCheckbox('')
    setdocRowCheckbox('')

    var objInput = {
      PracticeId: userData.practiceID,
      PatientID: claimDetails?.PatientID || selectedPatientId,
    }

    var sInputJSON = JSON.stringify(objInput);


    const url = `${APIConstants.PATIENT_PORTAL_URL}${NewEncounterConstants.GetPatientAllDocumentDetails}?sInputJSON=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sAuthToken}`

      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {

        const parsedData = JSON.parse(data)
        setallDocumentData(parsedData)

        if (parsedData) {
          setShowEncModal(true)
        }


      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }



  const GetDOCPDF = (doc) => {
    window.open(doc, '_blank');
    console.log("DOC", doc);


  };


  const handleSelectDocAllChange = () => {

    const allSelected = allDocumentData.every((_, index) => docRowCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setdocAllCheckbox([]);
      setdocRowCheckbox([]);
    } else {
      // Select all checkboxes
      setdocAllCheckbox(Array.from({ length: allDocumentData.length }, (_, index) => index));

      setdocRowCheckbox(Array.from({ length: allDocumentData.length }, (_, index) => index));

    }
  };




  const handleDocRowCheckbox = (index, item) => {
    if (docAllCheckbox.includes(index)) {

      setdocAllCheckbox(docAllCheckbox.filter((selectedRow) => selectedRow !== index));
      setdocRowCheckbox((prevSelectedRows) => prevSelectedRows.filter((selectedRow) => selectedRow !== index));
    } else {

      setdocAllCheckbox([...docAllCheckbox, index]);
      setdocRowCheckbox((prevSelectedRows) => [...prevSelectedRows, index]);
    }
  };



  const handleSelectDocuments = () => {
    const selectedExisting = docAllCheckbox.map((i) => allDocumentData[i]);

    const existingDocs = selectedExisting.map((doc) => ({

      fileName: doc.DocumentName,
      fileContent: "",
      PWK01: "",
      PWK02: "",
      PhyPath: doc.DocPhyPath,
      WebPath: doc.DocWebPath,
      Source: "Existing",
      Documentid: doc.Documentid,
      selectType: "",
      selectMethod: "EL"

    }));

    setSelectedDocs((prev) => [...prev, ...existingDocs]);

    setShowEncModal(false);
  };



  const handleOpenDeleteModal = (doc) => {
    setSelectedDocForDelete(doc);
    setSelectedDocName(doc.documentName);
    setShowDeleteModal(true);
  };



  const handleDeleteDocument = async () => {
    const doc = selectedDocForDelete;

    if (!doc) return;

    try {

      const url = `${APIConstants.BASE_URL_BILLING}${NewEncounterConstants.DeleteClaimAttachment}?sInputJSON={DocumentID:${doc.documentID}}`;

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sAuthToken}`
        }
      });

      if (!response.ok) {
        throw new Error("Failed to delete document");
      }
      setSelectedDocs(prev => prev.filter(d => d.documentID !== doc.documentID));
      setShowDeleteModal(false);
      setSuccessDeleteModal(true);
      handleGetClaimAttachments();

    } catch (error) {
      console.error("Delete error:", error);
    }
  };




  const handleRemoveSelectedDoc = (removeIndex) => {
    setSelectedDocs((prev) => prev.filter((_, i) => i !== removeIndex));
    setShowErrorModal(true)
  };


  const filteredDocs = allDocumentData.filter((doc) => {
    return (
      doc.DocDate.toLowerCase().includes(searchDocDate.toLowerCase()) &&
      doc.DocumentName.toLowerCase().includes(searchDocName.toLowerCase()) &&
      doc.DocTypeName.toLowerCase().includes(searchDocType.toLowerCase())
    );
  });



  const cleanFileName = (name = "") => name.split("?")[0];


  const handleUploadClaimAttachments = async () => {

    if (!validateDocuments()) {

      return;
    }

    setLoading(true);
    const inpuJson = {
      ClaimID: id || selectedClaimID,
      UploadedBy: userData.userID,
      PracticeId: userData.practiceID,
      PatientID: claimDetails?.PatientID || selectedPatientId,
      files: selectedDocs.map(f => ({
        fileName: cleanFileName(f.fileName),
        fileContent: f.fileContent || "",
        PWK01: f.selectType || "",
        PWK02: f.selectMethod || "",
        PhyPath: f.PhyPath || "",
        WebPath: f.WebPath || "",
        Source: f.Source || "Unknown"
      }))

    }
    const myInput = JSON.stringify(inpuJson);
    const inputData = JSON.stringify(myInput)


    try {
      const response = await fetch(APIConstants.BASE_URL_BILLING + NewEncounterConstants.UploadClaimAttachments, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',

        },
        body: inputData
      })


      if (response.status !== 200) {
        console.log("Error: Received response status", response.status);
        return;
      }
      const responseData = await response.json();
      if (responseData) {

        setShowUploadModal(true)

      }

      handleGetClaimAttachments()
      setSelectedDocs([])

      setTimeout(() => {
        setLoading(false);

      }, 100);


    } catch (error) {
      console.error('An error occurred:', error);
    }
  };



  const handleTypeChange = (index, value) => {
    const updated = [...selectedDocs];
    updated[index].selectType = value;
    setSelectedDocs(updated);
  };

  const handleMethodChange = (index, value) => {
    const updated = [...selectedDocs];
    updated[index].selectMethod = value;
    setSelectedDocs(updated);
  };




  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });
  };


  const handleLocalFileUpload = async (e) => {
    const files = Array.from(e.target.files);

    const convertedFiles = await Promise.all(
      files.map(async (file) => {
        const base64 = await convertFileToBase64(file);

        return {
          DocumentName: file.name,
          fileContent: base64,
          fileName: file.name,
          PWK01: selectType,
          PWK02: selectMethod,
          PhyPath: "",
          WebPath: "",
          Source: "NewUpload",
          selectType: "",
          selectMethod: "EL"
        };
      })
    );

    setSelectedDocs((prev) => [...prev, ...convertedFiles]);
  };


  useEffect(() => {
    handleGetClaimAttachments()
    handleGetClaimAttachmentTypes()

  }, []);




  const handleGetClaimAttachmentTypes = async () => {
    const url = `${APIConstants.COMMON_BASE_URL}${NewEncounterConstants.GetClaimAttachmentTypes}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',

      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {

        const parsedData = JSON.parse(data);

        setattachmentTypeData(parsedData)

      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }

 

  return (
    <div className="main-container" style={{ height: "100%" }}>
      <div className="container-style">
        <div className="table-style-container">

          {isLoading && (
            <div className="overlay">
              <div className="spinner-container">
                <div className="spinner-grow text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="spinner-grow text-warning" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="spinner-grow text-info" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          )}




          <table width="100%" cellPadding={3} cellSpacing={1} id="abc">
            <tr>
              <td>
                <div className="claimpageHeader">
                  <div
                    style={{
                      float: "left",
                      color: "White",
                      padding: "5px 5px 0 5px",
                    }}

                  >
                    Patient Information
                  </div>
                </div>

                <div style={{ height: "3px" }}></div>
                <div
                  id="pnlCollapsable"
                  style={{ border: "1px solid #18A6EC", width: "100%" }}
                >
                  <table
                    cellPadding={3}
                    cellSpacing={0}
                    width="100%"
                    style={{
                      borderCollapse: "separate",
                      borderSpacing: "1px",
                    }}
                  >
                    <tr className="rows">
                      <td style={{ width: '500px' }}>
                        <span className="cms1500fields">(2)</span>Patient
                        <span style={{ color: "Red" }}>*</span>
                        <input
                          type="text"
                          id="TxtPatientName"
                          width="35%"
                          className="textboxes"
                          value={searchPatientText}
                          onChange={(e) => setSearchPatientText(e.target.value)}
                          onKeyDown={handleKeyDown}
                        />
                        <div className="list-autocomplete">
                          <ul
                            className="patlist-style"
                            style={{ width: "221px", color: "black" }}
                          >
                            {Array.isArray(searchPatientData) &&
                              searchPatientData.map((suggestion) => (
                                <li
                                  key={suggestion.val}
                                  onClick={() =>
                                    handlePatientSuggestion(suggestion)
                                  }
                                >
                                  {suggestion.label}
                                </li>
                              ))}
                          </ul>
                        </div>
                        <label id="lblPatMRN"></label>
                        {selectedPatientId &&
                          <span
                            id="lnkPatDemo"
                            className="linkspan"
                            onClick={handleNewEncounterClick}
                          >
                            DM
                          </span>

                        }

                        {patientSecInsData && Object.keys(patientSecInsData).length > 0 && (
                          <span>
                            <FontAwesomeIcon style={{ marginLeft: '10px' }} icon={faShieldHalved} />
                          </span>
                        )}

                        <label id="lblClaimStatusFlag"></label>
                      </td>

                      <td style={{ paddingRight: "10px", width: '350px' }}>
                        <span className="cms1500fields">(3)</span> DOB:
                        <label style={{ marginLeft: "5px" }}>
                          {selectedDOB}
                        </label>
                      </td>

                      <td>
                        <span className="cms1500fields">(23)</span>
                        Prior Authorization:
                        <span style={{ color: "Red" }}></span>
                        <input
                          type="text"
                          id="TxtPriorAuthority"
                          width="50%"
                          className="textboxes"
                          value={priorAuthority}
                          onChange={(e) => setPriorAuthority(e.target.value)}
                        />
                      </td>
                    </tr>

                    <tr className="rows">
                      <td>
                        <span className="cms1500fields">(1)</span>Primary
                        Insurance Name:
                        <select
                          id="ddlinsurance"
                          className="textboxes"
                          width="57%"
                          value={
                            selectedInsurance?.insCoID ?? selectedInsurance?.InsCoID ?? "-1"
                          }
                          onChange={handleInsuranceChange}
                        >
                          <option value="-1"> &lt;--Select--&gt;</option>

                          {Array.isArray(patientInsData) &&
                            patientInsData.length > 0 ? (
                            patientInsData.map((insurance) => {
                              return (
                                <>
                                  <option
                                    key={
                                      insurance?.insCoID || insurance?.InsCoID
                                    }
                                    value={
                                      insurance?.insCoID || insurance?.InsCoID
                                    }
                                    selected={
                                      insurance?.insCoID || insurance?.InsCoID
                                    }
                                  >
                                    {insurance?.insConcatData ||
                                      insurance?.InsConcatData}
                                  </option>
                                </>
                              );
                            })
                          ) : (
                            <option value="-1"> &lt;--Select--&gt;</option>
                          )}
                        </select>


                        <br />
                        <label id="lblEndDate">
                          {formatInsDate(
                            new Date(selectedInsurance?.startDate)
                          ) || formatInsDate(selectedInsurance?.StartDate)}{" "}
                          {" - "}
                          {formatInsDate(
                            new Date(selectedInsurance?.endDate)
                          ) || formatInsDate(selectedInsurance?.EndDate)}
                        </label>
                        {isInsdata && (
                          <label id="lblEndDate">
                            {formatInsDate(
                              new Date(selectedInsData?.startDate) ||
                              selectedInsData.startDate
                            )}{" "}
                            {" - "}
                            {formatInsDate(
                              new Date(selectedInsData?.endDate || "")
                            )}
                          </label>
                        )}

                        <button
                          style={{
                            marginLeft: '20px',
                            backgroundColor: isPrimarySkipped ? '#ccc' : '',
                            color: isPrimarySkipped ? '#666' : '#fff',
                            cursor: isPrimarySkipped ? 'not-allowed' : 'pointer',
                            border: 'none',
                            borderRadius: '4px',

                          }}
                          className="diagbtn-style"
                          onClick={handleButtonClick}
                          disabled={isPrimarySkipped}
                        >
                          {isPrimarySkipped ? 'Primary Skipped' : 'Skip Primary'}
                        </button>

                      </td>

                      <td>
                        <span className="cms1500fields">(1a)</span> Policy #:
                        <label style={{ marginLeft: "5px" }}>
                          {selectedPatientInsurance}
                        </label>
                        <input
                          type="button"
                          id="btnEligibilitychk"
                          value="Check Eligibility"
                          className="but"
                        />
                        {showEligible && (
                          <FontAwesomeIcon
                            style={{ marginLeft: "1px" }}
                            icon={faCircleCheck}
                            className="success-icon"
                          />
                        )}
                        <i
                          id="ieligibilityError"
                          className=""
                          style={{ color: "#FCC000" }}
                          visible="false"
                        ></i>
                        <label
                          id="eligiblityMsgLabel"
                          className="successMessage"
                        ></label>
                      </td>
                      <td>
                        <div className="checkpt">
                          <input type="checkbox" id="chkIsPaerClaim" />
                          Do not send claim electronically
                        </div>
                      </td>
                    </tr>
                    <tr className="rows">
                      <td>
                        <span className="cms1500fields">(9)</span>Sec Insurance:
                        <span style={{ color: "Red" }}></span>
                        <select
                          id="ddlSecIns"
                          className="textboxes"
                          width="57%"
                          value={
                            selectedSecInsurance?.insCoID ??
                            selectedSecInsurance?.InsCoID ??
                            selectedSecInsurance?.InsCoName
                          }
                          onChange={handleSecInsuranceChange}
                        >
                          <option value="-1">&lt;--Select--&gt;</option>

                          {patientSecInsData && patientSecInsData.length > 0 ? (
                            patientSecInsData.map((insurance) => (
                              <option
                                key={insurance.insCoID ?? insurance.InsCoID}
                                value={insurance.insCoID ?? insurance.InsCoID}
                              >
                                {insurance.insCoName ??
                                  insurance.InsConcatData ??
                                  insurance?.InsCoName}
                              </option>
                            ))
                          ) : (
                            <option value="-1">&lt;--Select--&gt;</option>
                          )}
                        </select>
                        <input type="hidden" id="hdnSecIns" />
                        <br />
                        <label id="lblSecInsActiveDates">
                          {formatInsDate(
                            new Date(selectedSecInsurance?.startDate)
                          ) ||
                            formatInsDate(
                              new Date(selectedSecInsurance?.StartDate)
                            )}{" "}
                          {" - "}
                          {formatInsDate(
                            new Date(selectedSecInsurance?.endDate)
                          ) ||
                            formatInsDate(
                              new Date(selectedSecInsurance?.EndDate)
                            )}
                        </label>

                      </td>
                      <td>
                        <span className="cms1500fields">(9a)</span>Sec Policy #:
                        <label id="lblSecInsPolicy">
                          {selectedSecInsurance?.insPolicyNumber ??
                            selectedSecInsurance?.InsPolicyNumber}
                        </label>
                        <button className="but" onClick={handleSecIns}>Check Eligibility</button>
                        {showSecondaryEligible && (
                          <FontAwesomeIcon
                            style={{ marginLeft: "1px" }}
                            icon={faCircleCheck}
                            className="success-icon"
                          />
                        )}
                      </td>
                      <td></td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="claimpageHeader">
                  <div
                    style={{
                      float: "left",
                      color: "White",
                      padding: "5px 5px 0 5px",
                    }}
                  >
                    Dates:
                  </div>
                  <div
                    style={{

                      color: "White",
                      padding: "5px 5px 5px 80px",
                      marginLeft: '500px'
                    }}
                  >
                    Provider:
                  </div>
                  <div style={{ clear: "both" }}></div>
                </div>

                <div style={{ height: "3px" }}></div>

                <table
                  cellPadding={3}
                  cellSpacing={5}
                  bgcolor="#FFFFFF"
                  width="100%"
                  style={{ borderSpacing: "1px" }}
                >
                  <tr className="rows">
                    <td style={{ width: '140px' }} >
                      Appointment Date:
                      <span style={{ color: "Red" }}>*</span>
                    </td>

                    <td style={{ width: '350px' }}>
                      <CustomDatePicker
                        value={
                          appointmentDate ||
                          (claimDetails?.ClaimDOS
                            ? formatDOSDate(claimDetails?.ClaimDOS)
                            : "")
                        }
                        onChange={handleToAppointmentDateChange}
                        placeholderText="Select a date"
                        isReadOnly={false}
                        className={`custom-class ${startDate ? "default-selected" : ""

                          }`}
                      />
                    </td>
                    <td style={{ width: '200px' }} >
                      Scheduling Provider:
                      <span style={{ color: "Red" }}>*</span>
                    </td>

                    <td>
                      <select
                        name="select"
                        className="textboxes"
                        value={selectedPracticeProvider}
                        onChange={(e) =>
                          setSelectedPracticeProvider(e.target.value)}
                      >
                        <option value="">&lt;--Select--&gt;</option>

                        {practiceProvider.map((item, index) => (
                          <option value={item.ProviderID} key={index}>
                            {item.ProviderName}
                          </option>
                        ))}
                      </select>

                    </td>
                  </tr>
                  <tr className="rows">
                    <td style={{ width: '150px' }}>
                      From Date:
                      <span style={{ color: "Red" }}>*</span>
                    </td>

                    <td>
                      <CustomDatePicker
                        value={
                          startDate ||
                          (claimDetails?.ClaimDOS
                            ? formatDOSDate(claimDetails?.ClaimDOS)
                            : "")
                        }
                        onChange={handleFromDateChange}
                        placeholderText="Select a date"
                        isReadOnly={false}
                        className={`custom-class ${startDate ? "default-selected" : ""
                          }`}
                      />
                    </td>
                    <td style={{ width: '200px' }}>
                      <span className="cms1500fields">(24 J)</span> Rendering
                      Provider:
                      <span style={{ color: "Red" }}></span>
                    </td>

                    <td>

                      <select
                        name="select"
                        className="textboxes"
                        value={selectedRenderingProvider}
                        onChange={(e) =>
                          setSelectedRenderingProvider(e.target.value)
                        }
                      >
                        <option value="">&lt;--Select--&gt;</option>

                        {practiceProvider.map((item, index) => (
                          <option value={item.ProviderID} key={index}>
                            {item.ProviderName}
                          </option>
                        ))}
                      </select>

                    </td>
                  </tr>
                  <tr className="rows">
                    <td style={{ width: '150px' }}>
                      Through Date:
                      <span style={{ color: "Red" }}></span>

                    </td>

                    <td>

                      <CustomDatePicker
                        value={
                          endDate ||
                          (claimDetails?.ClaimDOS
                            ? formatDOSDate(claimDetails?.ClaimDOS)
                            : "")
                        }
                        onChange={handleToDateChange}
                        placeholderText="Select a date"
                        isReadOnly={false}
                        className={`custom-class ${startDate ? "default-selected" : ""
                          }`}
                      />
                    </td>
                    <td style={{ width: '290px' }}>
                      (17)
                      <select
                        name="select"
                        class="textboxes"
                        width="57%"
                        value={selectedProvidersCategory}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          setSelectedProvidersCategory(selectedValue);

                          if (selectedValue === 'DN') {
                            getPhysicianDropdown();
                          } else {
                            getPracticeProvidersOnly();
                          }
                        }}
                      >
                        {providerCategory.map((item, index) => (
                          <option value={item.Value}>{item.Label}</option>
                        ))}
                      </select>
                    </td>

                    <td>
                      <select
                        name="select"
                        class="textboxes"
                        width="57%"
                        onChange={handleSelectFilterProviders}
                        value={selectedFilterProvider}
                      >
                        <option value="-1">&lt;--Select--&gt;</option>

                        {(selectedProvidersCategory === 'DN'
                          ? physicianDropdownData
                          : filteredProviders
                        )?.map((provider) => (

                          <option
                            key={provider.ID || provider.ProviderID}
                            value={provider.ID || provider.ProviderID}
                          >
                            {provider.FirstName || provider.LastName
                              ? `${provider.FirstName ?? ""} ${provider.LastName ?? ""}`.trim() +
                              (provider.PhySpeciality?.trim() ? ` - ${provider.PhySpeciality}` : "")
                              : provider.ProviderName}
                          </option>


                        ))}

                      </select>
                    </td>
                  </tr>
                  <tr class="rows">
                    <td style={{ width: '150px' }}>To Approve:

                    </td>

                    <td>
                      <CustomDatePicker
                        value={
                          approveDate ||
                          (claimDetails?.PostingDate
                            ? formatDOSDate(claimDetails?.PostingDate)
                            : "")
                        }
                        onChange={handleToApproveDateChange}
                        placeholderText="Select a date"
                        isReadOnly={false}
                        className={`custom-select ${startDate ? "default-selected" : ""
                          }`}
                      />
                    </td>
                    <td colspan="2"></td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td>
                <div className="claimpageHeader">
                  <div
                    style={{
                      float: "left",
                      color: "White",
                      padding: "5px 5px 0 5px",
                    }}
                  >
                    <span className="cms1500fields">(29)</span> Copay:
                  </div>
                  <div
                    style={{
                      marginLeft: '600px',
                      color: "White",
                      padding: "5px 5px 5px 80px",
                    }}
                  >
                    Location:
                  </div>
                  <div style={{ clear: "both" }}></div>
                </div>

                <div style={{ height: "3px" }}></div>

                <table
                  cellPadding={3}
                  cellSpacing={0}
                  bgcolor="#FFFFFF"
                  width="100%"
                  style={{ borderCollapse: "separate", borderSpacing: "1px" }}
                >
                  <tr class="rows">
                    <td style={{ width: '200px' }}>Copay:</td>
                    <td style={{ width: '460px' }}>
                      <input
                        type="text"
                        id="TxtCopay"
                        width="57%"
                        class="textboxes"
                      // value={selectedCopayValue}
                      // onChange={(e) => setselectedCopayValue(e.target.value)}
                      />
                    </td>
                    <td style={{ width: '250px' }}>
                      (32)Service location address:
                      <span style={{ color: "Red" }}>*</span>
                    </td>
                    <td>
                      <select
                        name="select"
                        className={`textboxes mt-1 ${selectedLocation === "0" ? "red-bg" : "green-bg"
                          }`}
                        value={selectedLocation}
                        onChange={(e) => setSelectedLocation(e.target.value)}
                        title={
                          (() => {
                            const loc = locations.find(loc => loc.LocationId == selectedLocation);
                            return loc
                              ? `${loc.LocationName}, ${loc['Address (Main)']}, ${loc.City}, ${loc.State}, ${loc['Zip Code']}`
                              : '';
                          })()
                        }


                      >
                        <option value="0">&lt;--Select--&gt;</option>
                        {locations.map((item, index) => (
                          <option
                            style={{ width: "100px" }}
                            value={item.LocationId}
                            key={index}
                            title={`${item.LocationName}, ${item['Address (Main)']}, ${item.City}, ${item.State},${item['Zip Code']}`}

                          >
                            {item.LocationName}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr class="rows">
                    <td style={{ width: '200px' }}>
                      <span class="cms1500fields">(19)</span>
                      Additional claim Information:
                    </td>
                    <td>
                      <div>
                        <textarea
                          value={claimNotes}
                          onChange={(e) => setclaimNotes(e.target.value)}

                          width="57%"
                          className="textarea"
                          style={{
                            fontWeight: "bold",
                            resize: "auto",
                            height: "25px",
                            color: 'black'
                          }}
                        ></textarea>
                      </div>
                    </td>

                    <td style={{ width: '250px' }}>
                      (33) Billing address
                      <span style={{ color: "Red" }}>*</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        id="TxtPlaceofSvc"
                        width="57%"
                        className="textboxes"
                        value={selectedBillingAddress}
                        onChange={(e) =>
                          setSelectedBillingAddress(e.target.value)
                        }
                      />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <div class="claimpageHeader">
                  <div
                    style={{
                      float: "left",
                      color: "White",
                      padding: "5px 5px 0 5px",
                    }}
                  >
                    NPI:
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      color: "White",
                      padding: "5px 5px 5px 80px",
                    }}
                  ></div>
                  <div style={{ clear: "both" }}></div>
                </div>

                <div style={{ height: "3px" }}></div>

                <table
                  cellPadding={3}
                  cellSpacing={0}
                  bgcolor="#FFFFFF"
                  width="100%"
                  style={{ borderCollapse: "separate", borderSpacing: "1px" }}
                >
                  <tr className="rowsAlt">
                    <td style={{ width: '200px' }}>(24 b)Serivce Loc </td>
                    <td style={{ width: '460px' }}>
                      <select
                        name="select"
                        style={{ color: "black" }}
                        className="textboxes"
                        value={selectedServiceLocation}
                        onChange={(e) => handleSelectChange(e)}
                      >

                        <option value="">
                          &lt;--Select--&gt;
                        </option>
                        {ServiceLocations.map((item, index) => (
                          <option
                            key={index}
                            value={item.ID}
                            style={{ color: "black" }}
                          >
                            {item.PlaceOfService}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td style={{ width: '300px' }}>
                      (32 a) Service Location NPI:
                      <span style={{ color: "Red" }}>*</span>
                    </td>

                    <td>
                      <select
                        name="select"
                        className={`textboxes mt-1 ${selectedBillingNPI === "0" ||
                          selectedBillingNPI === ""
                          ? "red-bg"
                          : "green-bg"
                          }`}
                        value={selectedBillingNPI}
                        onChange={handleSelectBillingNPI}
                      >
                        <option value="0">
                          &lt;--Select--&gt;
                        </option>
                        {BillingNPIs.map((item, index) => (
                          <option value={item.NPI} key={index}>
                            {item.NamewithNPI}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr class="rows">
                    <td style={{ width: '200px' }}>
                      (33 a) Billing Provider NPI:
                      <span style={{ color: "Red" }}>*</span>{" "}
                    </td>

                    <td>
                      <select
                        name="select"
                        className={`textboxes mt-1 ${selectedCMS33a === "0" || selectedCMS33a === ""
                          ? "red-bg"
                          : "green-bg"
                          }`}
                        value={selectedCMS33a}
                        onChange={(e) => setSelectedCMS33a(e.target.value)}
                      >
                        <option value="0">
                          &lt;--Select--&gt;
                        </option>
                        {cms33aData.map((item, index) => (
                          <option value={item.NPI || item.claim33a} key={index}>
                            {item.NamewithNPI}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td style={{ width: '300px' }}>
                      (33 b) Billing Provider Taxonomy code:
                      <span style={{ color: "Red" }}>*</span>
                    </td>
                    <td>
                      <select
                        name="select"
                        className={`textboxes mt-1 ${selectedCMS33b === "0" || selectedCMS33b === ""
                          ? "red-bg"
                          : "green-bg"
                          }`}
                        value={selectedCMS33b}
                        onChange={(e) => setSelectedCMS33b(e.target.value)}
                      >
                        <option value="0">
                          &lt;--Select--&gt;
                        </option>
                        {cms33bData.map((item, index) => (
                          <option
                            style={{ width: "100px" }}
                            key={index}
                            value={item.TaxonomyCode || item.claim33b}
                          >
                            {item.NamewithTaxCode}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr class="rowsAlt">
                    <td colspan="4">
                      <table width="100%">
                        <tr>
                          <td>
                            <div id="divPracServicesBtns"></div>

                            <div style={{ display: "flex", gap: '10px' }}>
                              {BillingNPIs.map((item, index) => (
                                <div key={index}>
                                  {item.PracticeLabel && (
                                    <button
                                      className="but"
                                      onClick={() =>
                                        handlePracticeButtonClick(item)
                                      }
                                      value={`Selected ${item.PracticeLabel}`}
                                    >
                                      {item.PracticeLabel}
                                    </button>
                                  )}
                                </div>
                              ))}
                            </div>
                          </td>
                          <td style={{ width: '350px' }}>
                            Omit BOX 32
                            <input
                              type="checkbox"
                              checked={isBOX32checked}
                              onChange={(e) =>
                                setIsBox32Checked(e.target.checked)
                              }
                            />
                            {isBOX32checked ? (
                              <span style={{ display: "none" }}>0</span>
                            ) : (
                              <span style={{ display: "none" }}>1</span>
                            )}
                          </td>

                          <td id="tdResubcode" style={{ width: '500px' }}>
                            (22) Resubmit code:
                            <span style={{ color: "Red" }}>*</span>
                            <select
                              className="textboxes"
                              value={selectedResubmitCode}
                              onChange={(e) =>
                                setSelectedResubmitCode(e.target.value)
                              }
                            >
                              <option value="0" selected="selected">
                                N/A
                              </option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="137">137</option>
                            </select>
                          </td>
                          <td id="tdoriginalClaimNo">
                            Original claim #:
                            <input
                              type="text"
                              id="txtOriginalClaimNo"
                              class="textboxes"
                              value={selectedOriginalClaim || claimDetails?.PayerRefNumber
                              }
                              onChange={(e) =>
                                setSelectedOriginalClaim(e.target.value)
                              }
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr className="rows">
                    <td colSpan="4">
                      <div
                        id="Panel8"
                        bordercolor="#18A6EC"
                        borderwidth="1"
                        width="100%"
                      >
                        <span className="cms1500fields">(24)</span>
                        <span>
                          <span
                            className="linkspan"
                            id="lnkReview"
                            onClick={bindPatallclaims}
                          >
                            Review All
                          </span>
                        </span>
                        <table
                          id="gvInsuranceClaim"
                          width="100%"
                          cellPadding="3"
                          cellSpacing="1"
                        ></table>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>


          {isPatientSelected && (
            <>
              <div className="table-container" >
                <table
                  className="table bordered border-secondary responsive mt-1 "
                  style={{ marginLeft: "4px", width: "max-content" }}
                >
                  <thead>
                    <tr className="align-top" style={{ fontSize: "0.5rem" }}>
                      <th
                        className="col-sm col-th  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        #
                      </th>

                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        From
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        To
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Claim ID
                        <br />
                        <input
                          style={{ width: "100px", height: "30px", borderRadius: "5px", color: "black", color: "black" }}
                          type="text"
                          placeholder="Search"
                          value={claimIdSearch}
                          onChange={handleClaimIdSearchChange}
                        />
                      </th>

                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        New Claim ID
                        <br />
                        <input
                          style={{ width: "100px", height: "30px", borderRadius: "5px", color: "black" }}
                          type="text"
                          placeholder="Search"
                          value={newClaimIdSearch}
                          onChange={handleNewClaimIdSearchChange}
                        />
                      </th>

                      <th
                        className="col-sm col-th text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        <label style={{ width: "120px" }}>Provider Name</label>
                        <br />
                        <input
                          style={{ width: "100px", height: "30px", borderRadius: "5px", color: "black" }}
                          type="text"
                          placeholder="Search"
                          value={providerNameSearch}
                          onChange={handleProviderNameSearchChange}
                        />
                      </th>
                      <th
                        className="col col-th-style text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Procedure(24D)
                        <br />
                        <input
                          style={{ width: "100px", height: "30px", borderRadius: "5px", color: "black" }}
                          type="text"
                          placeholder="Search"
                          value={procedureSearch}
                          onChange={handleProcedureSearchChange}
                        />
                      </th>
                      <th
                        className="col-sm col-th  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Mod1
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Mod2
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Mod3
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Diag1
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Diag2
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Diag3
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Diag4
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Unit(24 G)
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7", width: "150px" }}
                      >
                        Unit Charge(24 F)
                      </th>

                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Apply Payment
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Total Charge
                      </th>

                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#f1f1c4" }}
                      >
                        <label
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            width: "90px",
                            fontSize: "1.1rem",
                          }}
                        >
                          Recieved Charge(Pri)
                        </label>
                      </th>

                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{
                          backgroundColor: "lightyellow",
                          backgroundColor: "lightyellow",
                        }}
                      >
                        <label
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            width: "90px",
                            fontSize: "1.1rem",
                          }}
                        >
                          Recieved Charge(Sec)
                        </label>
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        <label style={{ width: "80px" }}>
                          Contractual Adjustment
                        </label>
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        <label style={{ width: "80px" }}>
                          Secondary Pending
                        </label>
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Deductible
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Pat Rs
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Other Adjustment
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Federal Reduction
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Write-off
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Resubmit
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      >
                        Pri Dx
                      </th>
                      <th
                        className="col col-th-style  text-white border border-white"
                        style={{ backgroundColor: "#0173b7" }}
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRows?.map((row, index) => {

                      const claimRowData = claimRowsData[index];
                      const disabledRow = row.IsCPTMoved == 1;

                      return (
                        <tr
                          className={getRowClass(claimRowsData[index])}
                          title={
                            claimRowsData[index]?.IsCPTMoved == 1
                              ? `Moved to Claim ${claimRowsData[index]?.MovedToClaimID}`
                              : ""
                          }
                          key={index} ref={(el) => (suggestionRefs.current[index] = el)}>
                          <td>{index + 1}</td>
                          <td>
                            <CustomDatePicker
                              value={row?.fromDate}
                              onChange={(date) =>
                                setRows((prev) => {
                                  const updated = [...prev];
                                  updated[index].fromDate = date;
                                  return updated;
                                })
                              }
                              placeholderText="Select a date"
                              isReadOnly={disabledRow}
                              className="custom-class"
                            />
                          </td>
                          <td>
                            <CustomDatePicker
                              value={row?.toDate}
                              onChange={(date) =>
                                setRows((prev) => {
                                  const updated = [...prev];
                                  updated[index].toDate = date;
                                  return updated;
                                })
                              }
                              placeholderText="Select a date"
                              isReadOnly={disabledRow}
                              className="custom-class"
                            />
                          </td>
                          <td className="border border-white">{row?.ClaimId}</td>
                          <td className="border border-white"></td>
                          <td className="border border-white">
                            <label>{row?.providername}</label>
                            {id &&
                              <FontAwesomeIcon
                                style={{ marginLeft: "10px", color: "red", cursor: 'pointer', fontSize: '20px' }}
                                onClick={() => GetProviderPDF(claimRowData)}
                                icon={faFilePdf}
                              />
                            }
                          </td>
                          <td className="border border-white">
                            <input
                              type="text"
                              className="search-box-style"
                              disabled={disabledRow}
                              style={{ width: "100px" }}
                              placeholder="Procedure"
                              value={row.procedure}
                              onChange={(e) =>
                                handleCptChange(index, e.target.value)
                              }
                            />
                            <div style={{ position: "sticky" }}>
                              {row?.hideList && (
                                <ul
                                  className="list-style"
                                  style={{
                                    width: "180px",
                                    color: "black",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {Array.isArray(row.selectedCPTs) &&
                                    row.selectedCPTs.map(
                                      (suggestion, suggestionIndex) => (
                                        <li
                                          key={suggestionIndex}
                                          onClick={() =>
                                            saveCpt(index, suggestion)
                                          }
                                        >
                                          {`${suggestion?.CPTCode} - ${suggestion?.CPTDesc}`}
                                        </li>
                                      )
                                    )}
                                </ul>
                              )}
                            </div>
                            <input
                              type="checkbox"
                              disabled={disabledRow}
                              checked={
                                row.hasExistingClaim
                                  ? isCheckboxChecked[row.ID] || btnStatus == null
                                  : isCheckboxChecked[row.ID]
                              }
                              onChange={() => handleCheckboxClick(row.ID)}
                              style={{
                                filter: btnStatus == null ? "grayscale(80%) brightness(1)" : "none",
                                opacity: btnStatus == null ? 0.9 : 1,
                                cursor: btnStatus == null && "cursor",
                              }}
                            />
                          </td>

                          <td className="border border-white">
                            <input
                              type="text"
                              placeholder="Mod 1"
                              disabled={disabledRow}
                              className="search-box-style"
                              style={{ width: "100px" }}
                              value={row.mod1}
                              onChange={(e) =>
                                // fetchModList(index, e.target.value)
                                handleModChange(
                                  e.target.value,
                                  "mod1",
                                  index,
                                  "hideMod"
                                )
                              }
                            />
                            <div style={{ position: "sticky" }}>
                              {row.hideMod && (
                                <ul
                                  className="list-style"
                                  style={{
                                    width: "180px",
                                    color: "black",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {Array.isArray(row.modDataList) &&
                                    row.modDataList.map(
                                      (suggestion, suggestionIndex) => (
                                        <li
                                          key={suggestionIndex}
                                          onClick={() => saveTableData(
                                            index,
                                            "mod1",
                                            suggestion?.val,
                                            "hideMod"
                                          )}
                                        >
                                          {suggestion?.val}
                                        </li>
                                      )
                                    )}
                                </ul>
                              )}
                            </div>
                          </td>

                          <td className="border border-white">
                            <input
                              type="text"
                              placeholder="Mod 2"
                              disabled={disabledRow}
                              className="search-box-style"
                              style={{ width: "100px" }}
                              value={row.mod2}
                              onChange={(e) =>
                                // fetchModList(index, e.target.value)
                                handleModChange(
                                  e.target.value,
                                  "mod2",
                                  index,
                                  "hideMod1"
                                )
                              }
                            />
                            <div style={{ position: "sticky" }}>
                              {row.hideMod1 && (
                                <ul
                                  className="list-style"
                                  style={{
                                    width: "180px",
                                    color: "black",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {Array.isArray(row.modDataList) &&
                                    row.modDataList.map(
                                      (suggestion, suggestionIndex) => (
                                        <li
                                          key={suggestionIndex}
                                          onClick={() => saveTableData(
                                            index,
                                            "mod2",
                                            suggestion?.val,
                                            "hideMod1"
                                          )}
                                        >
                                          {suggestion?.val}
                                        </li>
                                      )
                                    )}
                                </ul>
                              )}
                            </div>
                          </td>

                          <td className="border border-white">
                            <input
                              type="text"
                              placeholder="Mod 3"
                              disabled={disabledRow}
                              className="search-box-style"
                              style={{ width: "100px" }}
                              value={row.mod3}
                              onChange={(e) =>
                                // fetchModList(index, e.target.value)
                                handleModChange(
                                  e.target.value,
                                  "mod3",
                                  index,
                                  "hideMod2"
                                )
                              }
                            />
                            <div style={{ position: "sticky" }}>
                              {row.hideMod2 && (
                                <ul
                                  className="list-style"
                                  style={{
                                    width: "180px",
                                    color: "black",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {Array.isArray(row.modDataList) &&
                                    row.modDataList.map(
                                      (suggestion, suggestionIndex) => (
                                        <li
                                          key={suggestionIndex}
                                          onClick={() => saveTableData(
                                            index,
                                            "mod3",
                                            suggestion?.val,
                                            "hideMod2"
                                          )}
                                        >
                                          {suggestion?.val}
                                        </li>
                                      )
                                    )}
                                </ul>
                              )}
                            </div>
                          </td>

                          <td className="border border-white">
                            <input
                              type="text"
                              className="search-box-style"
                              disabled={disabledRow}
                              placeholder="Diag 1"
                              style={{ width: "100px" }}
                              value={row.diag1}
                              onChange={(e) =>
                                handleDiagChange(
                                  e.target.value,
                                  "diag1",
                                  index,
                                  "hideDiag"
                                )
                              }
                            />
                            <div style={{ position: "sticky" }}>
                              {row.hideDiag && (
                                <ul
                                  className="list-style"
                                  style={{
                                    width: "180px",
                                    color: "black",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {Array.isArray(row.diagDataList) &&
                                    row.diagDataList.map(
                                      (suggestion, suggestionIndex) => (
                                        <li
                                          key={suggestionIndex}
                                          onClick={() =>
                                            saveTableData(
                                              index,
                                              "diag1",
                                              suggestion?.Value,
                                              "hideDiag"
                                            )
                                          }
                                        >
                                          {suggestion?.Value}
                                        </li>
                                      )
                                    )}
                                </ul>
                              )}
                            </div>
                          </td>

                          <td className="border border-white">
                            <input
                              type="text"
                              className="search-box-style"
                              placeholder="Diag 2"
                              disabled={disabledRow}
                              style={{ width: "100px" }}
                              value={row.diag2}
                              onChange={(e) =>
                                handleDiagChange(
                                  e.target.value,
                                  "diag2",
                                  index,
                                  "hideDiag1"
                                )
                              }
                            />
                            <div style={{ position: "sticky" }}>
                              {row.hideDiag1 && (
                                <ul
                                  className="list-style"
                                  style={{
                                    width: "180px",
                                    color: "black",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {Array.isArray(row.diagDataList) &&
                                    row.diagDataList.map(
                                      (suggestion, suggestionIndex) => (
                                        <li
                                          key={suggestionIndex}
                                          onClick={() =>
                                            saveTableData(
                                              index,
                                              "diag2",
                                              suggestion?.Value,
                                              "hideDiag1"
                                            )
                                          }
                                        >
                                          {suggestion?.Value}
                                        </li>
                                      )
                                    )}
                                </ul>
                              )}
                            </div>
                          </td>

                          <td className="border border-white">
                            <input
                              type="text"
                              className="search-box-style"
                              placeholder="Diag 3"
                              disabled={disabledRow}
                              style={{ width: "100px" }}
                              value={row.diag3}
                              onChange={(e) =>
                                handleDiagChange(
                                  e.target.value,
                                  "diag3",
                                  index,
                                  "hideDiag2"
                                )
                              }
                            />
                            <div style={{ position: "sticky" }}>
                              {row.hideDiag2 && (
                                <ul
                                  className="list-style"
                                  style={{
                                    width: "auto",
                                    color: "black",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {Array.isArray(row.diagDataList) &&
                                    row.diagDataList.map(
                                      (suggestion, suggestionIndex) => (
                                        <li
                                          key={suggestionIndex}
                                          onClick={() =>
                                            saveTableData(
                                              index,
                                              "diag3",
                                              suggestion?.Value,
                                              "hideDiag2"
                                            )
                                          }
                                        >
                                          {suggestion?.Value}
                                        </li>
                                      )
                                    )}
                                </ul>
                              )}
                            </div>
                          </td>

                          <td className="border border-white">
                            <input
                              type="text"
                              className="search-box-style"
                              disabled={disabledRow}
                              placeholder="Diag 4"
                              style={{ width: "100px" }}
                              value={row.diag4}
                              onChange={(e) =>
                                handleDiagChange(
                                  e.target.value,
                                  "diag4",
                                  index,
                                  "hideDiag3"
                                )
                              }
                            />
                            <div style={{ position: "sticky" }}>
                              {row.hideDiag3 && (
                                <ul
                                  className="list-style"
                                  style={{
                                    width: "180px",
                                    color: "black",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {Array.isArray(row.diagDataList) &&
                                    row.diagDataList.map(
                                      (suggestion, suggestionIndex) => (
                                        <li
                                          key={suggestionIndex}
                                          onClick={() =>
                                            saveTableData(
                                              index,
                                              "diag4",
                                              suggestion?.Value,
                                              "hideDiag3"
                                            )
                                          }
                                        >
                                          {suggestion?.Value}
                                        </li>
                                      )
                                    )}
                                </ul>
                              )}
                            </div>
                          </td>

                          <td className="border border-white">
                            <input
                              className="textboxes"
                              style={{ width: "70px" }}
                              disabled={disabledRow}
                              type="text"
                              value={row?.unit}
                              onChange={(e) => {
                                const newUnit = e.target.value;
                                saveTableData(index, "unit", newUnit);
                                const newTotalCharge = newUnit * row?.unitCharge;
                                saveTableData(index, "totalCharge", newTotalCharge);
                                updateGrandTotal(); // Update the grand total after each change
                              }

                              }
                            />
                          </td>
                          <td className="border border-white">
                            <input
                              className="textboxes"
                              style={{ width: "70px" }}
                              disabled={disabledRow}
                              type="text"
                              value={row?.unitCharge}
                              onChange={(e) => {
                                const newUnitCharge = e.target.value;
                                saveTableData(index, "unitCharge", newUnitCharge);
                                const newTotalCharge = row?.unit * newUnitCharge;
                                saveTableData(index, "totalCharge", newTotalCharge);
                                updateGrandTotal(); // Update the grand total after each change
                              }
                              }
                            />
                          </td>

                          <td className="border border-white">
                            <input
                              className="textboxes"
                              style={{ width: "70px" }}
                              disabled={disabledRow}
                              type="text"
                            />
                          </td>
                          <td className="border border-white">
                            <input
                              className="textboxes"
                              style={{ width: "70px" }}
                              type="text"
                              disabled={disabledRow}
                              value={row?.totalCharge}
                              onChange={(e) => {
                                saveTableData(
                                  index,
                                  "totalCharge",
                                  e.target.value
                                )
                                updateGrandTotal()
                              }
                              }
                            />
                          </td>

                          <td className="border border-white">
                            <label>{row?.recvdCharge}</label>
                          </td>

                          <td className="border border-white">
                            <label>{row?.SecrecvdCharge}</label>
                          </td>

                          <td className="border border-white">
                            <input
                              className="textboxes"
                              disabled={disabledRow}
                              style={{ width: "70px" }}
                              type="text"
                              value={row?.Adjustment}
                              onChange={(e) =>
                                saveTableData(index, "Adjustment", e.target.value)
                              }
                            />
                          </td>

                          <td className="border border-white">
                            <input
                              className="textboxes"
                              disabled={disabledRow}
                              style={{ width: "70px" }}
                              type="text"
                              value={row?.SecPendingAmt}
                              onChange={(e) =>
                                saveTableData(
                                  index,
                                  "SecPendingAmt",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className="border border-white">
                            <input
                              className="textboxes"
                              disabled={disabledRow}
                              style={{ width: "70px" }}
                              type="text"
                              value={row?.Deductible}
                              onChange={(e) =>
                                saveTableData(index, "Deductible", e.target.value)
                              }
                            />
                          </td>
                          <td className="border border-white">
                            <input
                              className="textboxes"
                              disabled={disabledRow}
                              style={{ width: "70px" }}
                              type="text"
                              value={row.PatientAmount}
                              onChange={(e) =>
                                saveTableData(
                                  index,
                                  "PatientAmount",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className="border border-white">
                            <label>{row.OtherAdjustment}</label>
                          </td>
                          <td className="border border-white">
                            <label>{row.FederalReduction}</label>
                          </td>

                          <td className="border border-white">
                            <input
                              className="textboxes"
                              disabled={disabledRow}
                              style={{ width: "70px" }}
                              type="text"
                              value={row.AdminWriteOff}
                              onChange={(e) =>
                                saveTableData(
                                  index,
                                  "AdminWriteOff",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          <td className="border border-white">
                            <input
                              className="textboxes"
                              disabled={disabledRow}
                              style={{ width: "15px" }}
                              type="checkbox"
                            />
                          </td>
                          <td className="border border-white">
                            <input
                              className="textboxes"
                              disabled={disabledRow}
                              style={{ width: "70px" }}
                              type="text"
                              value={row?.ClaimCPTLineNumber}
                              onChange={(e) =>
                                saveTableData(
                                  index,
                                  "ClaimCPTLineNumber",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          <td className="border border-white">
                            <FontAwesomeIcon
                              icon={faPlus}
                              onClick={denied == 1 ? checkThenAddRow : handleAddRow}
                              style={{ cursor: "pointer" }}
                            />
                            <br />
                            <FontAwesomeIcon
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "bolder",
                                cursor: "pointer",
                              }}
                              icon={faMinus}
                              onClick={() => handleRemoveRow(index)}
                            />
                          </td>
                          <td style={{ display: 'none' }}>{row?.ID}</td>
                        </tr>
                      )
                    })}
                    {showSuccessModal && (
                      <div className="alertfax-modal">
                        <label style={{ backgroundColor: "#18A6EC" }}></label>
                        <FontAwesomeIcon
                          style={{
                            float: "right",
                            fontWeight: "bolder",
                            fontSize: "1rem",
                            backgroundColor: "red",
                            padding: "5px",
                          }}
                          onClick={handleCloseModals}
                          icon={faXmark}
                        />
                        <p
                          style={{ backgroundColor: "#18A6EC", color: "white" }}
                        >
                          Claim updated successfully
                        </p>
                      </div>
                    )}
                    {showPaidErrorModal && (
                      <div className="alert-modal">
                        <p
                          className="mt-1"
                          style={{
                            backgroundColor: "#18A6EC",
                            color: "white",
                            justifyContent: "space-between",
                          }}
                        >
                          This claim is already paid. Are you sure to edit it ?
                        </p>
                        <button
                          className="btn btn-danger"
                          style={{
                            width: "60px",
                            height: "25px",
                            padding: "1px",
                            backgroundColor: "#dc3545",
                            color: "white",
                          }}
                          onClick={handleCloseModals}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-danger"
                          style={{
                            width: "60px",
                            height: "25px",
                            padding: "1px",
                            backgroundColor: "#dc3545",
                            color: "white",
                            marginLeft: "20px",
                          }}
                          onClick={handleAddRow}
                        >
                          Confirm
                        </button>
                      </div>
                    )}

                    {/* {showSelectErrorModal && (
                      <div className="alert-modal">
                        <p
                          className="mt-1"
                          style={{ backgroundColor: "#18A6EC", color: "white" }}
                        >
                          Are you sure to delete this CPT?{" "}
                        </p>
                        <button
                          className="btn btn-danger"
                          style={{
                            width: "60px",
                            height: "25px",
                            padding: "1px",
                            backgroundColor: "#dc3545",
                            color: "white",
                          }}
                          onClick={handleCloseModals}
                        >
                          cancel
                        </button>
                        <button
                          className="btn btn-danger"
                          style={{
                            width: "60px",
                            height: "25px",
                            padding: "1px",
                            backgroundColor: "#dc3545",
                            color: "white",
                            marginLeft: "5px",
                          }}
                          onClick={() => DeleteClaimCPT(claimData)}
                        >
                          confirm
                        </button>
                      </div>
                    )} */}

                    {showConfirmSaveModal && (
                      <div className="alert-modal">
                        <p
                          className="mt-1"
                          style={{ backgroundColor: "#18A6EC", color: "white" }}
                        >
                          Claim successfully delete !
                        </p>
                        <button
                          className="btn btn-danger"
                          style={{
                            width: "60px",
                            height: "25px",
                            padding: "1px",
                            backgroundColor: "#dc3545",
                            color: "white",
                          }}
                          onClick={handleCloseModals}
                        >
                          ok
                        </button>
                      </div>
                    )}

                    {errorMessage && (
                      <div className="alertmsg-modal">
                        <label style={{ backgroundColor: "#18A6EC" }}></label>
                        <FontAwesomeIcon
                          style={{
                            float: "right",
                            fontWeight: "bolder",
                            fontSize: "1rem",
                            backgroundColor: "red",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                          onClick={handleCloseModals}
                          icon={faXmark}
                        />
                        <div style={{ backgroundColor: "#18A6EC", color: "white", padding: "10px" }}>
                          {errorMessage.split("\n").map((msg, index) => (
                            <p key={index} style={{ margin: "4px 0 !important" }}>
                              {msg}
                            </p>
                          ))}
                        </div>
                      </div>
                    )}
                  </tbody>
                  <td align="right" colspan="26">
                    Total charges : (28)
                    <span className="cms1500fields"></span>$
                    <label
                      id="lblGrandTotal"
                      style={{ fontWeight: "bolder", paddingRight: "65px", paddingLeft: "4px" }}
                    >
                      {grandTotal}
                    </label>
                  </td>
                </table>
              </div>


              <table className="table table-hover table-striped table-bordered border border-white table-info responsive mt-1 " style={{ marginLeft: '5px', width: '100%' }}>

                <thead>

                  <tr className="align-top" style={{ fontSize: "0.5rem" }}>
                    <th
                      className="col-sm col-th  text-white border border-white"
                      style={{ backgroundColor: "#0173b7" }}
                    >
                      S NO
                    </th>

                    <th
                      className="col col-th-style  text-white border border-white"
                      style={{ backgroundColor: "#0173b7" }}
                    >
                      Document Name
                    </th>
                    <th
                      className="col col-th-style  text-white border border-white"
                      style={{ backgroundColor: "#0173b7" }}
                    >
                      Preview
                    </th>
                    <th
                      className="col col-th-style  text-white border border-white"
                      style={{ backgroundColor: "#0173b7" }}
                    >
                      Uploaded Date
                    </th>

                    <th className="col col-th-style  text-white border border-white"
                      style={{ backgroundColor: "#0173b7" }}>Type</th>


                    <th className="col col-th-style  text-white border border-white"
                      style={{ backgroundColor: "#0173b7" }}>Method</th>

                    <th className="col col-th-style  text-white border border-white"
                      style={{ backgroundColor: "#0173b7" }}>ACN</th>

                    <th className="col col-th-style  text-white border border-white"
                      style={{ backgroundColor: "#0173b7" }}>Action</th>
                  </tr>


                </thead>

                <tbody>
                  {attachmentsData.map((item, index) => (

                    <tr

                      key={index}
                    >
                      <td>{index + 1}</td>
                      <td>{item.documentName}</td>
                      <td>
                        <FontAwesomeIcon className="hide-on-print" style={{ marginLeft: '5px', color: 'red', cursor: 'pointer' }} onClick={() => GetDOCPDF(item.fileUrl)} icon={faFilePdf} />

                      </td>
                      <td>{formatDOSDate(item.uploadedDate)}</td>
                      <td>
                        {item.pwK01}
                      </td>
                      <td>
                        {item.pwK02}
                      </td>
                      <td>
                        {item.pwK06}
                      </td>
                      <td>
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{
                            marginLeft: "20px",
                            cursor: "pointer"
                          }}
                          onClick={() => handleOpenDeleteModal(item)}
                        />
                      </td>

                    </tr>
                  ))}

                </tbody>
              </table>






              <div className='upload-container'>
                <div className='border-container'>

                  <div className="d-flex" style={{ marginLeft: '50px' }}>


                    <input className="form-control form-control-sm" type="file" id="formFileMultiple" multiple style={{ width: '300px' }}

                      onChange={handleLocalFileUpload}
                    />

                    <label style={{ fontSize: '1.5rem', fontWeight: 'bold', marginLeft: '50px' }}>OR</label>
                    <button className='btn-style3' style={{ marginLeft: '20px', marginTop: '5px' }} onClick={handleGetPatientAllDocumentDetails}>Add Patient Documents</button>

                  </div>

                </div>


                {selectedDocs.length > 0 && (
                  <div style={{ marginTop: "20px" }}>


                    {selectedDocs.map((doc, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                          border: "1px solid lightgray",
                          padding: "10px",
                          borderRadius: "5px"
                        }}
                      >

                        <div>
                          <strong>{doc?.fileName}</strong>
                        </div>


                        <select style={{ marginLeft: "50px", padding: "5px" }}
                          value={doc.selectType ?? ""}
                          onChange={(e) => handleTypeChange(index, e.target.value)}
                        >
                          <option value="" >
                            &lt;--Select--&gt;
                          </option>
                          {attachmentTypeData.map((item, index) => (
                            <option value={item.ClaimAttachmentType} key={index}>{item.ClaimAttachmentType}-{item.ClaimAttachmentTypeDescription}</option>
                          ))}
                        </select>


                        <select style={{ marginLeft: "50px", padding: "5px" }}
                          value={doc.selectMethod}
                          onChange={(e) => handleMethodChange(index, e.target.value)}
                        >
                          <option value="">Select Method</option>
                          <option value="AA">AA - Available on Request</option>
                          <option value="BM">BM - By Mail</option>
                          <option value="EL">EL - Electronically Submitted</option>
                          <option value="FX">FX - By Fax</option>
                        </select>


                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{
                            marginLeft: "20px",
                            cursor: "pointer"
                          }}
                          onClick={() => handleRemoveSelectedDoc(index)}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {selectedDocs.length > 0 && id && (
                  <button className='btn-style3' style={{ marginLeft: '20px', marginTop: '5px' }} onClick={handleUploadClaimAttachments}>Upload Attachments</button>
                )}

              </div>



              {showEncModal && (
                <>

                  <Draggable>

                    <div className='patdialog-box'>
                      <FontAwesomeIcon style={{
                        width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black',
                        float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white'
                      }} onClick={handleCloseModals} icon={faXmark} />

                      <div className=' mt-2'>
                        <table className="table table-hover table-striped table-bordered border border-white table-info responsive mt-1 " style={{ marginLeft: '5px' }}>

                          <thead>

                            <tr className='align-top' >

                              <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>S No</th>

                              <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>DOS
                                <input
                                  type="text"
                                  placeholder="Search"
                                  value={searchDocDate}
                                  onChange={(e) => setSearchDocDate(e.target.value)}
                                  style={{ width: '120px', borderRadius: '5px' }}
                                />

                              </th>


                              <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Document Name
                                <br />
                                <input
                                  type="text"
                                  placeholder="Search"
                                  value={searchDocName}
                                  onChange={(e) => setSearchDocName(e.target.value)}
                                  style={{ width: '120px', borderRadius: '5px' }}
                                />
                              </th>

                              <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Document Type
                                <br />
                                <input
                                  type="text"
                                  placeholder="Search"
                                  value={searchDocType}
                                  onChange={(e) => setSearchDocType(e.target.value)}
                                  style={{ width: '120px', borderRadius: '5px' }}
                                />

                              </th>

                              <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Preview

                              </th>

                              <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                <input type="checkbox"
                                  onChange={() => handleSelectDocAllChange('all')} />
                              </th>



                            </tr>


                          </thead>

                          <tbody>

                            {filteredDocs.map((item, index) => (

                              <tr

                                key={index}
                              >
                                <td>{index + 1}</td>
                                <td>{item.DocDate}</td>
                                <td>{item.DocumentName}</td>
                                <td>{item.DocTypeName}</td>
                                <td>
                                  <FontAwesomeIcon className="hide-on-print" style={{ marginLeft: '5px', color: 'red', cursor: 'pointer' }} onClick={() => GetDOCPDF(item.DocWebPath)} icon={faFilePdf} />

                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={docAllCheckbox.includes(index)}
                                    onChange={() => handleDocRowCheckbox(index, item)}
                                  />

                                </td>

                              </tr>
                            ))}


                          </tbody>
                        </table>


                        <div style={{
                          flex: "0 0 auto", padding: "10px 15px", borderTop: "1px solid #ddd", textAlign: "right",
                          background: "#f8f8f8", position: "sticky", bottom: "0", zIndex: 10,
                        }}>
                          <input type="button" className="but" value="Select" onClick={handleSelectDocuments} />
                        </div>



                      </div>
                    </div>
                  </Draggable>
                </>

              )}




              <label className="ValidationMessage mb-4">{claimDetails.DataValidationMessage}</label>

              {showErrorModal && (
                <div className='alert-modal'>
                  <label></label>
                  <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                  <p>File Deleted!</p>

                </div>
              )}

              {showUploadModal && (
                <div className='alert-modal'>
                  <label></label>
                  <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                  <p>All Files Uploaded Successfully!</p>

                </div>
              )}


              {showDeleteModal && (
                <div className='alert-modal'>
                  <label></label>
                  <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                  <p>Are you sure you want to delete this document {selectedDocName}?</p>

                  <button className='btn-style3' onClick={handleDeleteDocument} >Yes</button>
                  <button className='btn-style3' onClick={handleCloseModals} >No</button>

                </div>
              )}


              {successDeleteModal && (
                <div className='alert-modal'>
                  <label></label>
                  <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                  <p>File Deleted Successfully!</p>

                </div>
              )}

              {showValidationModal && (
                <div className='alert-modal'>
                  <label></label>
                  <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                  <p>⚠️ Please select both Type and Method for all files before uploading.</p>

                </div>
              )}



              <div className="d-flex" style={{ marginLeft: "600px" }}>
                {/* {btnStatus === "" ||
                  (btnStatus === null && (
                    <>
                      {claimRowsData?.length > 0 && (
                        <button
                          className="diagbtn-style"
                          onClick={UpdateBtnclick}
                        >
                          Update For Approval
                        </button>
                      )}
                      {claimRowsData?.length == 0 && (
                        <button
                          className="diagbtn-style"
                          style={{ marginLeft: "5px" }}
                          onClick={GenerateNewClaims}
                        >
                          Generate New Claim
                        </button>
                      )}


                    </>
                  ))}


                {(Object.values(isCheckboxChecked).some(val => val)) && (
                  <button
                    className="diagbtn-style"
                    style={{ marginLeft: "5px" }}
                    onClick={GenerateNewClaims}
                  >
                    Generate New Claim
                  </button>
                )}


                {btnStatus == 1 && (
                  <>
                    <button className="diagbtn-style ml-1" onClick={UpdateBtnclick}>
                      Update For Approval
                    </button>

                  </>
                )}



                {(btnStatus == 1 || denied == 1) && (
                  <button
                    className="diagbtn-style"
                    style={{ marginLeft: "5px" }}
                    onClick={SaveSecondaryClaim}
                  >
                    Secondary Claims
                  </button>
                )}




                {btnStatus == 2 && (
                  <>
                    <button className="diagbtn-style" onClick={UpdateBtnclick}>
                      Update For Approval
                    </button>

                    <button
                      className="diagbtn-style"
                      style={{ marginLeft: "5px" }}
                      onClick={GenerateNewClaims}
                    >
                      Generate New Claim
                    </button>
                  </>
                )}

                {denied ? (
                  <>
                    <button
                      className="diagbtn-style"
                      style={{ marginLeft: "5px" }}
                      onClick={UpdateBtnclick}
                    >
                      Resubmit For Approval
                    </button>


                  </>

                ) : null} */}
                {/* 3 -> sent */}
                {/* 1->paid */}
                {/* 2 - > rejected */}
                {/* 4->pending */}
                {
                  isPartiallyDenied ? (
                    <>
                      <button
                        className="diagbtn-style"
                        style={{ marginLeft: "5px" }}
                        onClick={SaveSecondaryClaim}
                      >
                        Secondary Claims
                      </button>
                      <button
                        className="diagbtn-style"
                        onClick={CorrectPartiallyDeniedClaim}
                      >
                        Resubmit For Approval
                      </button>
                      <button
                        className="diagbtn-style"
                        style={{ marginLeft: "5px" }}
                        onClick={GenerateNewClaims}
                      >
                        Generate New Claim
                      </button>
                    </>
                  ) :
                    denied == 1 ? (
                      <>
                        <button
                          className="diagbtn-style"
                          style={{ marginLeft: "5px" }}
                          onClick={SaveSecondaryClaim}
                        >
                          Secondary Claims
                        </button>
                        <button
                          className="diagbtn-style"
                          onClick={UpdateBtnclick}
                        >
                          Resubmit For Approval
                        </button>
                        {Object.values(isCheckboxChecked).some((checked) => checked) && (
                          <button
                            className="diagbtn-style"
                            style={{ marginLeft: "5px" }}
                            onClick={GenerateNewClaims}
                          >
                            Generate New Claim
                          </button>
                        )}
                      </>
                    ) :
                      (btnStatus == 1 || btnStatus == 2) ? (
                        <>
                          <button
                            className="diagbtn-style"
                            style={{ marginLeft: "5px" }}
                            onClick={SaveSecondaryClaim}
                          >
                            Secondary Claims
                          </button>

                          <button
                            className="diagbtn-style"
                            style={{ marginLeft: "5px" }}
                            onClick={UpdateBtnclick}
                          >
                            Update For Approval
                          </button>

                          {Object.values(isCheckboxChecked).some((checked) => checked) && (
                            <button
                              className="diagbtn-style"
                              style={{ marginLeft: "5px" }}
                              onClick={GenerateNewClaims}
                            >
                              Generate New Claim
                            </button>
                          )}
                        </>
                      ) :
                        btnStatus != null ? (
                          <>
                            <button
                              className="diagbtn-style"
                              onClick={UpdateBtnclick}
                            >
                              Update For Approval
                            </button>

                            {Object.values(isCheckboxChecked).some((checked) => checked) && (
                              <button
                                className="diagbtn-style"
                                style={{ marginLeft: "5px" }}
                                onClick={GenerateNewClaims}
                              >
                                Generate New Claim
                              </button>
                            )}
                          </>
                        ) : (
                          <>
                            {hasExistingClaim && (
                              <button
                                className="diagbtn-style"
                                onClick={UpdateBtnclick}
                              >
                                Update For Approval
                              </button>
                            )}

                            {(!hasExistingClaim ||
                              Object.values(isCheckboxChecked).some((checked) => checked)) && (
                                <button
                                  className="diagbtn-style"
                                  style={{ marginLeft: "5px" }}
                                  onClick={GenerateNewClaims}
                                >
                                  Generate New Claim
                                </button>
                              )}
                          </>
                        )
                }


              </div>
            </>
          )}
        </div>
      </div>

    </div>
  );
};

export default NewEncounterPage;
